/*
  Anonymous Actions
*/
export const AUTHENTICATING_USER_REQUEST = 'AUTHENTICATING_USER_REQUEST';
export const AUTHENTICATING_USER_SUCCEDDED = 'AUTHENTICATING_USER_SUCCEDDED';
export const AUTHENTICATING_USER_FAILED = 'AUTHENTICATING_USER_FAILED';

export const FETCHING_USER_PROFILE = 'FETCHING_USER_PROFILE';
export const FETCHING_USER_PROFILE_SUCCEEDED = 'FETCHING_USER_PROFILE_SUCCEEDED';
export const FETCHING_USER_PROFILE_FAILED = 'FETCHING_USER_PROFILE_FAILED';

export const FETCHING_SSO_URL_REQUEST = 'FETCHING_SSO_URL_REQUEST';
export const FETCHING_SSO_URL_SUCCEEDED = 'FETCHING_SSO_URL_SUCCEEDED';
export const FETCHING_SSO_URL_FAILED = 'FETCHING_SSO_URL_FAILED';

export const SSO_AUTHENTICATION_FAILED = 'SSO_AUTHENTICATION_FAILED';
export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST';
export const LOGOUT_USER = 'LOGOUT_USER';

/*
  Workspace Actions
*/
export const FETCH_WORKSPACES_REQUEST = 'FETCH_WORKSPACES_REQUEST';
export const FETCING_WORKSPACES_SUCCEEDED = 'FETCING_WORKSPACES_SUCCEEDED';
export const FETCING_WORKSPACES_FAILED = 'FETCING_WORKSPACES_FAILED';

export const FETCH_WORKSPACE_REQUEST = 'FETCH_WORKSPACE_REQUEST';
export const FETCHING_WORKSPACE_SUCCEEDED = 'FETCHING_WORKSPACE_SUCCEEDED';
export const FETCHING_WORKSPACE_FAILED = 'FETCHING_WORKSPACE_FAILED';

export const UPDATE_WORKSPACE_REQUEST = 'UPDATE_WORKSPACE_REQUEST';
export const UPDATE_WORKSPACE_SUCCEEDED = 'UPDATE_WORKSPACE_SUCCEEDED';
export const UPDATE_WORKSPACE_FAILED = 'UPDATE_WORKSPACE_FAILED';

export const SWITCH_WORKSPACE_REQUEST = 'SWITCH_WORKSPACE_REQUEST';
export const SWITCH_WORKSPACE = 'SWITCH_WORKSPACE';

/*
  Storyboard Actions
*/
export const CREATE_STORYBOARD_REQUEST = 'CREATE_STORYBOARD_REQUEST';
export const CREATING_STORYBOARD_SUCCEEDED = 'CREATING_STORYBOARD_SUCCEEDED';
export const CREATING_STORYBOARD_FAILED = 'CREATING_STORYBOARD_FAILED';

export const UPDATE_STORYBOARD_REQUEST = 'UPDATE_STORYBOARD_REQUEST';
export const UPDATING_STORYBOARD_SUCCEEDED = 'UPDATING_STORYBOARD_SUCCEEDED';
export const UPDATING_STORYBOARD_FAILED = 'UPDATING_STORYBOARD_FAILED';
export const UPDATE_STORYBOARD_ITEM = 'UPDATE_STORYBOARD_ITEM';

/*
  Prompt Creation Actions
*/
export const GENERATE_OUTLINE_REQUEST = 'GENERATE_OUTLINE_REQUEST';
export const GENERATING_OUTLINE_SUCCEEDED = 'GENERATING_OUTLINE_SUCCEEDED';
export const GENERATING_OUTLINE_FAILED = 'GENERATING_OUTLINE_FAILED';

export const FETCH_AI_THEME_REQUEST = 'FETCH_AI_THEME_REQUEST';
export const FETCHING_AI_THEME_SUCCEEDED = 'FETCHING_AI_THEME_SUCCEEDED';
export const FETCHING_AI_THEME_FAILED = 'FETCHING_AI_THEME_FAILED';

export const ADD_PROMPT_SECTION_DATA = 'ADD_PROMPT_SECTION_DATA';
export const DELETE_PROMPT_SECTION_DATA = 'DELETE_PROMPT_SECTION_DATA';
export const UPDATE_PROMPT_SECTION_DATA = 'UPDATE_PROMPT_SECTION_DATA';
export const UPDATE_PROMPT_SECTION_ORDER_DATA = 'UPDATE_PROMPT_SECTION_ORDER_DATA';
export const UPDATE_PROMPT_CREATION_DATA = 'UPDATE_PROMPT_CREATION_DATA';
export const RESET_PROMPT_CREATION_FLOW = 'RESET_PROMPT_CREATION_FLOW';

export const GENERATE_STORYBOARD_FROM_PROMPT_REQUEST = 'GENERATE_STORYBOARD_FROM_PROMPT_REQUEST';
export const GENERATING_STORYBOARD_FROM_PROMPT_SUCCEEDED = 'GENERATING_STORYBOARD_FROM_PROMPT_SUCCEEDED';
export const GENERATING_STORYBOARD_FROM_PROMPT_FAILED = 'GENERATING_STORYBOARD_FROM_PROMPT_FAILED';

export const FETCH_STORYBOARDS_REQUEST = 'FETCH_STORYBOARDS_REQUEST';
export const FETCHING_STORYBOARDS_SUCCEEDED = 'FETCHING_STORYBOARDS_SUCCEEDED';
export const FETCHING_STORYBOARDS_FAILED = 'FETCHING_STORYBOARDS_FAILED';

export const FETCH_STORYBOARD_REQUEST = 'FETCH_STORYBOARD_REQUEST';
export const FETCHING_STORYBOARD_SUCCEEDED = 'FETCHING_STORYBOARD_SUCCEEDED';
export const FETCHING_STORYBOARD_FAILED = 'FETCHING_STORYBOARD_FAILED';

export const DELETE_STORYBOARD_REQUEST = 'DELETE_STORYBOARD_REQUEST';
export const DELETING_STORYBOARD_SUCCEEDED = 'DELETING_STORYBOARD_SUCCEEDED';
export const DELETING_STORYBOARD_FAILED = 'DELETING_STORYBOARD_FAILED';

export const CLONE_STORYBOARD_REQUEST = 'CLONE_STORYBOARD_REQUEST';
export const CLONING_STORYBOARD_SUCCEEDED = 'CLONING_STORYBOARD_SUCCEEDED';
export const CLONING_STORYBOARD_FAILED = 'CLONING_STORYBOARD_FAILED';

export const FETCH_STORYBOARD_USERS = 'FETCH_STORYBOARD_USERS';
export const FETCHING_STORYBOARD_USERS_SUCCEEDED = 'FETCHING_STORYBOARD_USERS_SUCCEEDED';
export const FETCHING_STORYBOARD_USERS_FAILED = 'FETCHING_STORYBOARD_USERS_FAILED';

export const ADD_USERS_TO_STORYBOARD = 'ADD_USERS_TO_STORYBOARD';
export const ADD_USERS_TO_STORYBOARD_SUCCEEDED = 'ADD_USERS_TO_STORYBOARD_SUCCEEDED';
export const ADD_USERS_TO_STORYBOARD_FAILED = 'ADD_USERS_TO_STORYBOARD_FAILED';

export const UPDATE_STORYBOARD_USER_ACCESS = 'UPDATE_STORYBOARD_USER_ACCESS';
export const UPDATE_STORYBOARD_USER_ACCESS_SUCCEEDED = 'UPDATE_STORYBOARD_USER_ACCESS_SUCCEEDED';
export const UPDATE_STORYBOARD_USER_ACCESS_FAILED = 'UPDATE_STORYBOARD_USER_ACCESS_FAILED';

export const REMOVE_USER_FROM_STORYBOARD = 'REMOVE_USER_FROM_STORYBOARD';
export const REMOVE_USER_FROM_STORYBOARD_SUCCEEDED = 'REMOVE_USER_FROM_STORYBOARD_SUCCEEDED';
export const REMOVE_USER_FROM_STORYBOARD_FAILED = 'REMOVE_USER_FROM_STORYBOARD_FAILED';

export const SET_STORYBOARD_USER_ROLE = 'SET_STORYBOARD_USER_ROLE';
export const UPDATE_STORYBOARD_USER_ROLE = 'UPDATE_STORYBOARD_USER_ROLE';

export const INVALIDATE_STORYBOARD_STATE = 'INVALIDATE_STORYBOARD_STATE';

export const INVALIDATE_STORYBOARDS_STATE = "INVALIDATE_STORYBOARDS_STATE";

export const MAKE_HOME_PAGE_FOR_STORYBOARD = "MAKE_HOME_PAGE_FOR_STORYBOARD";
export const MAKE_HOME_PAGE_FOR_STORYBOARD_SUCCEEDED = "MAKE_HOME_PAGE_FOR_STORYBOARD_SUCCEEDED";
export const MAKE_HOME_PAGE_FOR_STORYBOARD_FAILED = "MAKE_HOME_PAGE_FOR_STORYBOARD_FAILED";

export const INITIATE_PPT_UPLOAD_FOR_STORYBOARD = 'INITIATE_PPT_UPLOAD_FOR_STORYBOARD';
export const UPDATE_PPT_UPLOAD_FOR_STORYBOARD_PROGRESS = 'UPDATE_PPT_UPLOAD_FOR_STORYBOARD_PROGRESS';

export const CREATE_STORYBOARD_FROM_PPT_REQUEST = 'CREATE_STORYBOARD_FROM_PPT_REQUEST';
export const CREATING_STORYBOARD_FROM_PPT_SUCCEEDED = 'CREATING_STORYBOARD_FROM_PPT_SUCCEEDED';
export const CREATING_STORYBOARD_FROM_PPT_FAILED = 'CREATING_STORYBOARD_FROM_PPT_FAILED';

export const CREATE_STORYBOARD_FROM_FIGMA_REQUEST = 'CREATE_STORYBOARD_FROM_FIGMA_REQUEST';
export const CREATING_STORYBOARD_FROM_FIGMA_SUCCEEDED = 'CREATING_STORYBOARD_FROM_FIGMA_SUCCEEDED';
export const CREATING_STORYBOARD_FROM_FIGMA_FAILED = 'CREATING_STORYBOARD_FROM_FIGMA_FAILED';

export const FETCH_DOMAINS_REQUEST = 'FETCH_DOMAINS_REQUEST';
export const FETCHING_DOMAINS_SUCCEEDED = 'FETCHING_DOMAINS_SUCCEEDED';
export const FETCHING_DOMAINS_FAILED = 'FETCHING_DOMAINS_FAILED';

export const INVALIDATE_STORYBOARD_PAGES = 'INVALIDATE_STORYBOARD_PAGES';

export const TRIGGER_PAGE_PROCESSING_FOR_STORYBOARD = 'TRIGGER_PAGE_PROCESSING_FOR_STORYBOARD';

/**
 * Site Performance 
 **/

export const FETCH_PAGE_PERFORMANCE_METRICS_REQUEST = 'FETCH_PAGE_PERFORMANCE_METRICS_REQUEST';
export const FETCHING_PAGE_PERFORMANCE_METRICS_SUCCEEDED = 'FETCHING_PAGE_PERFORMANCE_METRICS_SUCCEEDED';
export const FETCHING_PAGE_PERFORMANCE_METRICS_FAILED = 'FETCHING_PAGE_PERFORMANCE_METRICS_FAILED';

export const FETCH_PAGE_PERFORMANCE_HISTORY_REQUEST = 'FETCH_PAGE_PERFORMANCE_HISTORY_REQUEST';
export const FETCHING_PAGE_PERFORMANCE_HISTORY_SUCCEEDED = 'FETCHING_PAGE_PERFORMANCE_HISTORY_SUCCEEDED';
export const FETCHING_PAGE_PERFORMANCE_HISTORY_FAILED = 'FETCHING_PAGE_PERFORMANCE_HISTORY_FAILED';

export const INVALIDATE_PAGE_PERFORMANCE = 'INVALIDATE_PAGE_PERFORMANCE';

/**
 * Template Actions
 **/
export const FETCH_TEMPLATE_REQUEST = 'FETCH_TEMPLATE_REQUEST';
export const FETCHING_TEMPLATE_SUCCEEDED = 'FETCHING_TEMPLATE_SUCCEEDED';
export const FETCHING_TEMPLATE_FAILED = 'FETCHING_TEMPLATE_FAILED';

export const CREATE_STORYBOARD_FROM_TEMPLATE = 'CREATE_STORYBOARD_FROM_TEMPLATE';
export const CREATING_STORYBOARD_FROM_TEMPLATE_SUCCEEDED = 'CREATING_STORYBOARD_FROM_TEMPLATE_SUCCEEDED';
export const CREATING_STORYBOARD_FROM_TEMPLATE_FAILED = 'CREATING_STORYBOARD_FROM_TEMPLATE_FAILED';

export const FETCH_CATEGORIES_AND_INDUSTRIES_REQUEST = 'FETCH_CATEGORIES_AND_INDUSTRIES_REQUEST';
export const FETCHING_CATEGORIES_AND_INDUSTRIES_SUCCEEDED = 'FETCHING_CATEGORIES_AND_INDUSTRIES_SUCCEEDED';
export const FETCHING_CATEGORIES_AND_INDUSTRIES_FAILED = 'FETCHING_CATEGORIES_AND_INDUSTRIES_FAILED';

export const CREATE_TEMPLATE_REQUEST = 'CREATE_TEMPLATE_REQUEST';
export const CREATING_TEMPLATE_SUCCEEDED = 'CREATING_TEMPLATE_SUCCEEDED';
export const CREATING_TEMPLATE_FAILED = 'CREATING_TEMPLATE_FAILED';

export const UPDATE_TEMPLATE_REQUEST = 'UPDATE_TEMPLATE_REQUEST';
export const UPDATING_TEMPLATE_SUCCEEDED = 'UPDATING_TEMPLATE_SUCCEEDED';
export const UPDATING_TEMPLATE_FAILED = 'UPDATING_TEMPLATE_FAILED';

export const DELETE_TEMPLATE_REQUEST = 'DELETE_TEMPLATE_REQUEST';
export const DELETING_TEMPLATE_SUCCEEDED = 'DELETING_TEMPLATE_SUCCEEDED';
export const DELETING_TEMPLATE_FAILED = 'DELETING_TEMPLATE_FAILED';

export const UPDATE_TEMPLATE_VISIBILITY_REQUEST = 'UPDATE_TEMPLATE_VISIBILITY_REQUEST';
export const UPDATING_TEMPLATE_VISIBILITY_SUCCEEDED = 'UPDATING_TEMPLATE_VISIBILITY_SUCCEEDED';
export const UPDATING_TEMPLATE_VISIBILITY_FAILED = 'UPDATING_TEMPLATE_VISIBILITY_FAILED';

/**
 * Page Actions
 **/
export const CREATE_PAGE_REQUEST = 'CREATE_PAGE_REQUEST';
export const CREATING_PAGE_SUCCEEDED = 'CREATING_PAGE_SUCCEEDED';
export const CREATING_PAGE_FAILED = 'CREATING_PAGE_FAILED';

export const UPDATE_PAGE_REQUEST = 'UPDATE_PAGE_REQUEST';
export const UPDATING_PAGE_SUCCEEDED = 'UPDATING_PAGE_SUCCEEDED';
export const UPDATING_PAGE_FAILED = 'UPDATING_PAGE_FAILED';

export const PUBLISH_PAGE_REQUEST = 'PUBLISH_PAGE_REQUEST';
export const PUBLISHING_PAGE_SUCCEEDED = 'PUBLISHING_PAGE_SUCCEEDED';
export const PUBLISHING_PAGE_FAILED = 'PUBLISHING_PAGE_FAILED';

export const CREATE_PAGE_PUBLISH_REQUEST = 'CREATE_PAGE_PUBLISH_REQUEST';
export const UPDATE_PAGE_PUBLISH_REQUEST = 'UPDATE_PAGE_PUBLISH_REQUEST';
export const INVALIDATE_PAGE_PUBLISH_REQUEST = 'INVALIDATE_PAGE_PUBLISH_REQUEST';

export const UNPUBLISH_PAGE_REQUEST = 'UNPUBLISH_PAGE_REQUEST';
export const UNPUBLISHING_PAGE_SUCCEEDED = 'UNPUBLISHING_PAGE_SUCCEEDED';
export const UNPUBLISHING_PAGE_FAILED = 'UNPUBLISHING_PAGE_FAILED';

export const INVALIDATE_UNPUBLISH_PAGE = 'INVALIDATE_UNPUBLISH_PAGE';

export const INVALIDATE_PAGE_STATE = 'INVALIDATE_PAGE_STATE';
export const INVALIDATE_PAGE_NAVIGATION = 'INVALIDATE_PAGE_NAVIGATION';


export const RESTORE_PAGE_REQUEST = 'RESTORE_PAGE_REQUEST';
export const RESTORING_PAGE_SUCCEEDED = 'RESTORING_PAGE_SUCCEEDED';
export const RESTORING_PAGE_FAILED = 'RESTORING_PAGE_FAILED';

export const SEARCH_PAGES_FOR_STORYBOARD_REQUEST = 'SEARCH_PAGES_FOR_STORYBOARD_REQUEST';
export const SEARCHING_PAGES_FOR_STORYBOARD_SUCCEEDED = 'SEARCHING_PAGES_FOR_STORYBOARD_SUCCEEDED';
export const SEARCHING_PAGES_FOR_STORYBOARD_FAILED = 'SEARCHING_PAGES_FOR_STORYBOARD_FAILED';
export const REVALIDATE_PAGES_FOR_STORYBOARD_REQUEST = 'REVALIDATE_PAGES_FOR_STORYBOARD_REQUEST';

export const QUERY_PAGES_FOR_STORYBOARD_REQUEST = 'QUERY_PAGES_FOR_STORYBOARD_REQUEST';
export const QUERY_PAGES_FOR_STORYBOARD_SUCCEEDED = 'QUERY_PAGES_FOR_STORYBOARD_SUCCEEDED';
export const QUERY_PAGES_FOR_STORYBOARD_FAILED = 'QUERY_PAGES_FOR_STORYBOARD_FAILED';
export const INVALIDATE_PAGE_QUERY = 'INVALIDATE_PAGE_QUERY';

export const FETCH_PAGES_FOR_SELECTION_REQUEST = 'FETCH_PAGES_FOR_SELECTION_REQUEST';
export const FETCHING_PAGES_FOR_SELECTION_SUCCEEDED = 'FETCHING_PAGES_FOR_SELECTION_SUCCEEDED';
export const FETCHING_PAGES_FOR_SELECTION_FAILED = 'FETCHING_PAGES_FOR_SELECTION_FAILED';

export const INVALIDATE_PAGES_FOR_SELECTION = 'INVALIDATE_PAGES_FOR_SELECTION';

export const FETCH_PAGE_REQUEST = 'FETCH_PAGE_REQUEST';
export const FETCHING_PAGE_SUCCEEDED = 'FETCHING_PAGE_SUCCEEDED';
export const FETCHING_PAGE_FAILED = 'FETCHING_PAGE_FAILED';

export const FETCH_PAGE_ALIAS_REQUEST = 'FETCH_PAGE_ALIAS_REQUEST';
export const FETCHING_PAGE_ALIAS_SUCCEEDED = 'FETCHING_PAGE_ALIAS_SUCCEEDED';
export const FETCHING_PAGE_ALIAS_FAILED = 'FETCHING_PAGE_ALIAS_FAILED';

export const CREATE_PAGE_ALIAS_REQUEST = 'CREATE_PAGE_ALIAS_REQUEST';
export const CREATING_PAGE_ALIAS_SUCCEEDED = 'CREATING_PAGE_ALIAS_SUCCEEDED';
export const CREATING_PAGE_ALIAS_FAILED = 'CREATING_PAGE_ALIAS_FAILED';

export const UPDATE_PAGE_ALIAS_REQUEST = 'UPDATE_PAGE_ALIAS_REQUEST';
export const UPDATING_PAGE_ALIAS_SUCCEEDED = 'UPDATING_PAGE_ALIAS_SUCCEEDED';
export const UPDATING_PAGE_ALIAS_FAILED = 'UPDATING_PAGE_ALIAS_FAILED';

export const DELETE_PAGE_ALIAS_REQUEST = 'DELETE_PAGE_ALIAS_REQUEST';
export const DELETING_PAGE_ALIAS_SUCCEEDED = 'DELETING_PAGE_ALIAS_SUCCEEDED';
export const DELETING_PAGE_ALIAS_FAILED = 'DELETING_PAGE_ALIAS_FAILED';

export const INVALIDATE_ALIASES = 'INVALIDATE_ALIASES';

export const DELETE_PAGE_REQUEST = 'DELETE_PAGE_REQUEST';
export const DELETING_PAGE_SUCCEEDED = 'DELETING_PAGE_SUCCEEDED';
export const DELETING_PAGE_FAILED = 'DELETING_PAGE_FAILED';
export const INVALIDATE_PAGE_DELETE = 'INVALIDATE_PAGE_DELETE';

export const UPDATE_PAGE_VISIBILITY_REQUEST = 'UPDATE_PAGE_VISIBILITY_REQUEST'
export const UPDATE_PAGE_VISIBILITY_SUCCEEDED = 'UPDATE_PAGE_VISIBILITY_SUCCEEDED'
export const UPDATE_PAGE_VISIBILITY_FAILED = 'UPDATE_PAGE_VISIBILITY_FAILED'

export const PAGE_SEEK_INDEXING_REQUEST = 'PAGE_SEEK_INDEXING_REQUEST';
export const PAGE_SEEK_INDEXING_SUCCEEDED = 'PAGE_SEEK_INDEXING_SUCCEEDED';
export const PAGE_SEEK_INDEXING_FAILED = 'PAGE_SEEK_INDEXING_FAILED';

export const DISABLE_PAGE_SEEK_INDEXING = 'DISABLE_PAGE_SEEK_INDEXING';

export const UPDATE_PAGE_SETTINGS = 'UPDATE_PAGE_SETTINGS';

export const UPDATE_PAGES_TO_RENDER = 'UPDATE_PAGES_TO_RENDER';

export const UPDATE_HOME_PAGE_FOR_STORYBAORD = 'UPDATE_HOME_PAGE_FOR_STORYBAORD';

export const REARRANGE_PAGE_WIDGETS = 'REARRANGE_PAGE_WIDGETS';
export const REARRANGE_PAGE_WIDGETS_SUCCEEDED = 'REARRANGE_PAGE_WIDGETS_SUCCEEDED';
export const REARRANGE_PAGE_WIDGETS_FAILED = 'REARRANGE_PAGE_WIDGETS_FAILED';

export const FETCH_SLIDES_FOR_PAGE_REQUEST = 'FETCH_SLIDES_FOR_PAGE_REQUEST';
export const FETCH_SLIDES_FOR_PAGE_SUCCEEDED = 'FETCH_SLIDES_FOR_PAGE_SUCCEEDED';
export const FETCH_SLIDES_FOR_PAGE_FAILED = 'FETCH_SLIDES_FOR_PAGE_FAILED';

// Flipbook 

export const UPDATE_FLIPBOOK_PAGES_TO_RENDER = 'UPDATE_FLIPBOOK_PAGES_TO_RENDER';
export const UPDATE_FLIPBOOK_HYPERLINK_SLIDE = 'UPDATE_FLIPBOOK_HYPERLINK_SLIDE';

/**
 * 
 * Auto save pages
*/
export const START_AUTO_SAVE_PAGE_TASK = 'START_AUTO_SAVE_PAGE_TASK';
export const STOP_AUTO_SAVE_PAGE_TASK = 'STOP_AUTO_SAVE_PAGE_TASK';
export const AUTO_SAVE_PAGE_REQUEST = 'AUTO_SAVE_PAGE_REQUEST';
export const AUTO_SAVING_PAGE_SUCCEEDED = 'AUTO_SAVING_PAGE_SUCCEEDED';
export const AUTO_SAVING_PAGE_FAILED = 'AUTO_SAVING_PAGE_FAILED';

/**
 * LandingPage Settings
 **/
export const UPDATE_LANDING_PAGE_SETTINGS_REQUEST = 'UPDATE_LANDING_PAGE_SETTINGS_REQUEST'
export const UPDATE_LANDING_PAGE_SETTINGS_SUCCEEDED = 'UPDATE_LANDING_PAGE_SETTINGS_SUCCEEDED'
export const UPDATE_LANDING_PAGE_SETTINGS_FAILED = 'UPDATE_LANDING_PAGE_SETTINGS_FAILED'

/**
 * Editor Actions
 **/
export const EDITOR_CREATE_SESSION = 'EDITOR_CREATE_SESSION';
export const EDITOR_CREATE_SEGMENT = 'EDITOR_CREATE_SEGMENT';
export const EDITOR_SPLIT_PAGE_BY_SELECTION = 'EDITOR_SPLIT_PAGE_BY_SELECTION';
export const EDITOR_SWITCH_BREAKPOINT = 'EDITOR_SWITCH_BREAKPOINT';
export const EDITOR_CREATE_WIDGET = 'EDITOR_CREATE_WIDGET';
export const EDITOR_DELETE_WIDGET = 'EDITOR_DELETE_WIDGET';
export const EDITOR_SELECT_WIDGET_REQUEST = 'EDITOR_SELECT_WIDGET_REQUEST';
export const EDITOR_SELECT_WIDGET = 'EDITOR_SELECT_WIDGET';
export const EDITOR_SELECT_PAGE_WIDGET = 'EDITOR_SELECT_PAGE_WIDGET';
export const EDITOR_SELECT_ACTIVE_SEGMENT = 'EDITOR_SELECT_ACTIVE_SEGMENT';
export const EDITOR_UNSELECT_WIDGET = 'EDITOR_UNSELECT_WIDGET'
export const EDITOR_DESELECT_WIDGETS = 'EDITOR_DESELECT_WIDGETS';
export const EDITOR_SELECT_ALL_WIDGETS = 'EDITOR_SELECT_ALL_WIDGETS';
export const EDITOR_SELECT_WIDGET_RANGE = 'EDITOR_SELECT_WIDGET_RANGE';

export const EDITOR_ATTACH_TO_CONTAINER = 'EDITOR_ATTACH_TO_CONTAINER';
export const EDITOR_BULK_ATTACH_TO_CONTAINER = 'EDITOR_BULK_ATTACH_TO_CONTAINER';
export const EDITOR_UPDATE_WIDGET_LAYOUT = 'EDITOR_UPDATE_WIDGET_LAYOUT';
export const EDITOR_BULK_UPDATE_WIDGET_LAYOUT = 'EDITOR_BULK_UPDATE_WIDGET_LAYOUT';
export const EDITOR_UPDATE_WIDGET_PROPERTY = 'EDITOR_UPDATE_WIDGET_PROPERTY';
export const EDITOR_BULK_UPDATE_WIDGET_PROPERTY = 'EDITOR_BULK_UPDATE_WIDGET_PROPERTY';
export const EDITOR_APPLY_WIDGET_PROPERTY_CHANGES = 'EDITOR_APPLY_WIDGET_PROPERTY_CHANGES';
export const EDITOR_APPLY_BULK_WIDGET_PROPERTY_CHANGES = 'EDITOR_APPLY_BULK_WIDGET_PROPERTY_CHANGES';
export const EDITOR_UPDATE_WIDGET_ACTIONS = 'EDITOR_UPDATE_WIDGET_ACTIONS';
export const EDITOR_UPDATE_WIDGET_CONTENT = 'EDITOR_UPDATE_WIDGET_CONTENT';
export const EDITOR_UPDATE_THEMES = 'EDITOR_UPDATE_THEMES';
export const EDITOR_UPDATE_APPEARANCE = 'EDITOR_UPDATE_APPEARANCE';
export const EDITOR_UPDATE_BRAND_COLORS = 'EDITOR_UPDATE_BRAND_COLORS';
export const EDITOR_UPDATE_WIDGET_NAME = 'EDITOR_UPDATE_WIDGET_NAME';
export const EDITOR_UPDATE_PAGE_SETTINGS = 'EDITOR_UPDATE_PAGE_SETTINGS';
export const EDITOR_RECALCULATE_LAYOUT = 'EDITOR_RECALCULATE_LAYOUT';
export const EDITOR_APPLY_LAYOUT_CHANGES = 'EDITOR_APPLY_LAYOUT_CHANGES';
export const EDITOR_TOGGLE_EDIT_MODE = 'EDITOR_TOGGLE_EDIT_MODE';
export const EDITOR_TOGGLE_HOTSPOT_VIEW = 'EDITOR_TOGGLE_HOTSPOT_VIEW';
export const EDITOR_BULK_UPDATE_WIDGET_ORDER = 'EDITOR_BULK_UPDATE_WIDGET_ORDER';

export const EDITOR_UPDATE_WIDGET_TEMPLATE_PROPERTY = 'EDITOR_UPDATE_WIDGET_TEMPLATE_PROPERTY';

export const EDITOR_UPDATE_GUIDELINES = 'EDITOR_UPDATE_GUIDELINES';

export const EDITOR_UPDATE_TOOLS_SETTINGS = 'EDITOR_UPDATE_TOOLS_SETTINGS';

export const EDITOR_COPY_WIDGETS = 'EDITOR_COPY_WIDGETS';
export const EDITOR_CUT_WIDGETS = 'EDITOR_CUT_WIDGETS';
export const EDITOR_CLONE_WIDGETS = 'EDITOR_CLONE_WIDGETS';
export const EDITOR_ARRANGE_WIDGETS = 'EDITOR_ARRANGE_WIDGETS';
export const EDITOR_ARRANGE_CAROUSEL_WIDGETS = 'EDITOR_ARRANGE_CAROUSEL_WIDGETS';
export const EDITOR_ALIGN_WIDGETS = 'EDITOR_ALIGN_WIDGETS';

export const EDITOR_LAYOUT_CHANGES_INDICATOR = 'EDITOR_LAYOUT_CHANGES_INDICATOR';
export const EDITOR_INVALIDATE_LAYOUT_CHANGES_INDICATOR = 'EDITOR_INVALIDATE_LAYOUT_CHANGES_INDICATOR';

export const EDITOR_FORM_SWITCH_STEP = 'EDITOR_FORM_SWITCH_STEP';
export const EDITOR_FORM_INSERT_FIELD = 'EDITOR_FORM_INSERT_FIELD';
export const EDITOR_FORM_FIELD_TYPE_CHANGE = 'EDITOR_FORM_FIELD_TYPE_CHANGE';

export const SUBMIT_CONTACT_FORM = 'SUBMIT_CONTACT_FORM';
export const SUBMIT_OTP_FORM = 'SUBMIT_OTP_FORM';
export const OTP_RESEND = 'OTP_RESEND';

export const EDITOR_CALCULATE_PAGE_HEIGHT = 'EDITOR_CALCULATE_PAGE_HEIGHT'

export const EDITOR_REPLACE_WIDGETS = 'EDITOR_REPLACE_WIDGETS';
export const EDITOR_UPDATE_WIDGET_EDITOR_STATE = 'EDITOR_UPDATE_WIDGET_EDITOR_STATE';
export const EDITOR_BULK_UPDATE_WIDGET_EDITOR_STATE = 'EDITOR_BULK_UPDATE_WIDGET_EDITOR_STATE';
export const EDITOR_UPDATE_SPATIAL_SETTING_MODE = 'EDITOR_UPDATE_SPATIAL_SETTING_MODE';
export const EDITOR_UPDATE_FLIPBOOK_SETTING_MODE = 'EDITOR_UPDATE_FLIPBOOK_SETTING_MODE';
export const EDITOR_RECALCULATE_SECTION_COLUMN_WIDTHS = 'EDITOR_RECALCULATE_SECTION_COLUMN_WIDTHS';

export const EDITOR_CREATE_GROUP_WIDGET = 'EDITOR_CREATE_GROUP_WIDGET';
export const EDITOR_UNGROUP_WIDGET = 'EDITOR_UNGROUP_WIDGET';

export const EDITOR_CLONE_PAGE = 'EDITOR_CLONE_PAGE';
export const EDITOR_CLONE_PAGES = 'EDITOR_CLONE_PAGES';
export const EDITOR_CLONE_SLIDE = 'EDITOR_CLONE_SLIDE';

export const CLONE_LANDING_PAGE_REQUEST = 'CLONE_LANDING_PAGE_REQUEST';
export const CLONE_LANDING_PAGE_FAILED = 'CLONE_LANDING_PAGE_FAILED';
export const CLONE_LANDING_PAGE_SUCCEEDED = 'CLONE_LANDING_PAGE_SUCCEEDED';

export const GENERATE_ALT_TEXT_FOR_WIDGET_REQUEST = 'GENERATE_ALT_TEXT_FOR_WIDGET_REQUEST';
export const GENERATING_ALT_TEXT_FOR_WIDGET_SUCCEEDED = 'GENERATING_ALT_TEXT_FOR_WIDGET_SUCCEEDED';
export const GENERATING_ALT_TEXT_FOR_WIDGET_FAILED = 'GENERATING_ALT_TEXT_FOR_WIDGET_FAILED';

/**
 * Interactive Content Actions
*/
export const EDITOR_INTERACTIVE_CONTENT_CREATE_PAGE = 'EDITOR_INTERACTIVE_CONTENT_CREATE_PAGE';
export const EDITOR_INTERACTIVE_CONTENT_SWITCH_PAGE = 'EDITOR_INTERACTIVE_CONTENT_SWITCH_PAGE';

/*
  User Actions
*/
export const UPDATING_USER_PROFILE = 'UPDATING_USER_PROFILE';
export const UPDATING_USER_PROFILE_FAILED = 'UPDATING_USER_PROFILE_FAILED';
export const UPDATING_USER_PROFILE_SUCCEEDED = 'UPDATING_USER_PROFILE_SUCCEEDED';

export const CHANGING_PASSWORD = 'CHANGING_PASSWORD';
export const CHANGING_PASSWORD_SUCCEEDED = 'CHANGING_PASSWORD_SUCCEEDED';
export const CHANGING_PASSWORD_FAILED = 'CHANGING_PASSWORD_FAILED';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCEEDED = 'FORGOT_PASSWORD_SUCCEEDED';
export const FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED';

export const VALIDATING_PASSWORD_RESET_LINK = 'VALIDATING_PASSWORD_RESET_LINK';
export const VALIDATING_PASSWORD_RESET_LINK_SUCCEDDED = 'VALIDATING_PASSWORD_RESET_LINK_SUCCEDDED';
export const VALIDATING_PASSWORD_RESET_LINK_FAILED = 'VALIDATING_PASSWORD_RESET_LINK_FAILED';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCEEDED = 'RESET_PASSWORD_SUCCEEDED';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';

export const USER_REGISTRATION_REQUEST = 'USER_REGISTRATION_REQUEST';
export const USER_REGISTRATION_SUCCEDDED = 'USER_REGISTRATION_SUCCEDDED';
export const USER_REGISTRATION_FAILED = 'USER_REGISTRATION_FAILED';

/**
 * Fonts
*/
export const FETCH_FONTS_REQUEST = 'FETCH_FONTS_REQUEST';
export const FETCHING_FONTS_SUCCEEDED = 'FETCHING_FONTS_SUCCEEDED';
export const FETCHING_FONTS_FAILED = 'FETCHING_FONTS_FAILED';

export const INITIATE_FONT_UPLOAD = 'INITIATE_FONT_UPLOAD';
export const UPDATE_FONT_UPLOAD_PROGRESS = 'UPDATE_FONT_UPLOAD_PROGRESS';
export const INSTALL_FONTS = 'INSTALL_FONTS';
export const UNINSTALL_FONTS = 'UNINSTALL_FONTS';
export const ASSOCIATE_FONTS_WITH_WIDGET = 'ASSOCIATE_FONTS_WITH_WIDGET';
export const BATCH_ASSOCIATE_FONTS_WITH_WIDGETS = 'BATCH_ASSOCIATE_FONTS_WITH_WIDGETS';
export const INVALIDATE_FONT_UPLOAD_ERROR = 'INVALIDATE_FONT_UPLOAD_ERROR';

export const UPLOAD_FONT_REQUEST = 'UPLOAD_FONT_REQUEST';
export const UPLOADING_FONT_SUCCEEDED = 'UPLOADING_FONT_SUCCEEDED';
export const UPLOADING_FONT_FAILED = 'UPLOADING_FONT_FAILED';

export const DELETE_FONT_REQUEST = 'DELETE_FONT_REQUEST';
export const DELETING_FONT_SUCCEEDED = 'DELETING_FONT_SUCCEEDED';
export const DELETING_FONT_FAILED = 'DELETING_FONT_FAILED';

/**
 * User Management
 */
export const FETCHING_USERS_REQUEST = 'FETCHING_USERS_REQUEST';
export const FETCHING_USERS_SUCCEEDED = 'FETCHING_USERS_SUCCEEDED';
export const FETCHING_USERS_FAILED = 'FETCHING_USERS_FAILED';
export const INVALIDATE_USERS = 'INVALIDATE_USERS';

export const UPDATE_USER_ACCESS_REQUEST = "UPDATE_USER_ACCESS_REQUEST";
export const UPDATING_USER_ACCESS_SUCCEEDED = "UPDATING_USER_ACCESS_SUCCEEDED";
export const UPDATING_USER_ACCESS_FAILED = "UPDATING_USER_ACCESS_FAILED";

export const INVALIDATE_USER_ACCESS = 'INVALIDATE_USER_ACCESS';


export const INVITE_USER_REQUEST = 'INVITE_USER_REQUEST';
export const INVITE_USER_SUCCEEDED = 'INVITE_USER_SUCCEEDED';
export const INVITE_USER_FAILED = 'INVITE_USER_FAILED';
export const INVALIDATE_INVITE_USER = 'INVALIDATE_INVITE_USER';

export const FETCHING_USER_INVITATION = 'FETCHING_USER_INVITATION';
export const FETCHING_USER_INVITATION_SUCCEDDED = 'FETCHING_USER_INVITATION_SUCCEDDED';
export const FETCHING_USER_INVITATION_FAILED = 'FETCHING_USER_INVITATION_FAILED';

export const UPDATE_INVITATION_ROLE = 'UPDATE_INVITATION_ROLE';
export const UPDATE_INVITATION_ROLE_SUCCEEDED = 'UPDATE_INVITATION_ROLE_SUCCEEDED';
export const UPDATE_INVITATION_ROLE_FAILED = 'UPDATE_INVITATION_ROLE_FAILED';

export const FETCHING_INVITATIONS_REQUEST = 'FETCHING_INVITATIONS_REQUEST';
export const FETCHING_INVITATIONS_SUCCEEDED = 'FETCHING_INVITATIONS_SUCCEEDED';
export const FETCHING_INVITATIONS_FAILED = 'FETCHING_INVITATIONS_FAILED';

export const RESEND_USER_INVITATION = 'RESEND_USER_INVITATION';
export const RESEND_USER_INVITATION_SUCCEEDED = 'RESEND_USER_INVITATION_SUCCEEDED';
export const RESEND_USER_INVITATION_FAILED = 'RESEND_USER_INVITATION_FAILED';

export const DELETE_USER_INVITATION = 'DELETE_USER_INVITATION';
export const DELETE_USER_INVITATION_SUCCEEDED = 'DELETE_USER_INVITATION_SUCCEEDED';
export const DELETE_USER_INVITATION_FAILED = 'DELETE_USER_INVITATION_FAILED';

/**
 * User Roles
 */
export const FETCH_USER_ROLES = "FETCH_USER_ROLES";
export const FETCH_USER_ROLE = "FETCH_USER_ROLE";
export const FETCH_USER_ROLE_SUCCEEDED = "FETCH_USER_ROLE_SUCCEEDED";
export const FETCH_USER_ROLE_FAILED = "FETCH_USER_ROLE_FAILED";
export const FETCH_USER_ROLES_SUCCEEDED = "FETCH_USER_ROLES_SUCCEEDED";
export const FETCH_USER_ROLES_FAILED = "FETCH_USER_ROLES_FAILED";

export const CREATE_USER_ROLE = "CREATE_USER_ROLE";
export const CREATING_USER_ROLE_SUCCEEDED = "CREATING_USER_ROLE_SUCCEEDED";
export const CREATING_USER_ROLE_FAILED = "CREATING_USER_ROLE_FAILED";

export const UPDATE_USER_ROLE = "UPDATE_USER_ROLE";
export const UPDATING_USER_ROLE_SUCCEEDED = "UPDATING_USER_ROLE_SUCCEEDED";
export const UPDATING_USER_ROLE_FAILED = "UPDATING_USER_ROLE_FAILED";

export const DELETE_USER_ROLE = "DELETE_USER_ROLE";
export const DELETING_USER_ROLE_SUCCEEDED = "DELETING_USER_ROLE_SUCCEEDED";
export const DELETING_USER_ROLE_FAILED = "DELETING_USER_ROLE_FAILED";

/**
 * Media
 */
export const TOGGLE_MEDIA_LIBRARY = 'TOGGLE_MEDIA_LIBRARY';
export const INITIATE_MEDIA_UPLOAD = 'INITIATE_MEDIA_UPLOAD';
export const INVALIDATE_UPLOAD_ERROR = 'INVALIDATE_UPLOAD_ERROR';
export const UPDATE_MEDIA_UPLOAD_PROGRESS = 'UPDATE_MEDIA_UPLOAD_PROGRESS';
export const UPLOAD_MEDIA_REQUEST = 'UPLOAD_MEDIA_REQUEST';
export const UPLOADING_MEDIA_SUCCEEDED = 'UPLOADING_MEDIA_SUCCEEDED';
export const UPLOADING_MEDIA_FAILED = 'UPLOADING_MEDIA_FAILED';
export const INVALIDATE_MEDIA_LIBRARY = 'TOGGLE_MEDIA_LIBRARY';

export const SEARCH_MEDIA_REQUEST = 'SEARCH_MEDIA_REQUEST';
export const SEARCHING_MEDIA_SUCCEEDED = 'SEARCHING_MEDIA_SUCCEEDED';
export const SEARCHING_MEDIA_FAILED = 'SEARCHING_MEDIA_FAILED';

export const DELETE_MEDIA_REQUEST = 'DELETE_MEDIA_REQUEST';
export const DELETING_MEDIA_SUCCEEDED = 'DELETING_MEDIA_SUCCEEDED';
export const DELETING_MEDIA_FAILED = 'DELETING_MEDIA_FAILED';
export const INVALIDATE_MEDIA_DELETE_ERROR = 'INVALIDATE_MEDIA_DELETE_ERROR';

/**
 * Brankit Palatte ids
 */
export const FETCHING_PALETTE_IDS_REQUEST = "FETCHING_PALETTE_IDS_REQUEST";
export const FETCHING_PALETTE_IDS_SUCCEEDED = "FETCHING_PALETTE_IDS_SUCCEEDED";
export const FETCHING_PALETTE_IDS_FAILED = "FETCHING_PALETTE_IDS_FAILED";
export const UPDATE_BRANDKIT_ENABLE_TOGGLE_REQUEST = "UPDATE_BRANDKIT_ENABLE_TOGGLE_REQUEST"
export const UPDATING_BRANDKIT_ENABLE_TOGGLE_SUCCEEDED = "UPDATE_BRANDKIT_ENABLE_TOGGLE_SUCCEEDED"
export const UPDATING_BRANDKIT_ENABLE_TOGGLE_FAILED = "UPDATE_BRANDKIT_ENABLE_TOGGLE_FAILED"

/**
 * Brandkit Palette Component
 */
export const FETCH_PALETTE_COMPONENT_REQUEST = "FETCHING_PALETTE_COMPONENT_REQUEST";
export const FETCHING_PALETTE_COMPONENT_SUCCEEDED = "FETCHING_PALETTE_COMPONENT_SUCCEEDED";
export const FETCHING_PALETTE_COMPONENT_FAILED = "FETCHING_PALETTE_COMPONENT_FAILED";


/**
 * Brandkit Media
 */
export const BRANDKIT_TOGGLE_MEDIA_LIBRARY = 'BRANDKIT_TOGGLE_MEDIA_LIBRARY';
export const BRANDKIT_INITIATE_MEDIA_UPLOAD = 'BRANDKIT_INITIATE_MEDIA_UPLOAD';
export const BRANDKIT_INVALIDATE_MEDIA_UPLOAD_ERROR = 'BRANDKIT_INVALIDATE_MEDIA_UPLOAD_ERROR';
export const BRANDKIT_UPDATE_MEDIA_UPLOAD_PROGRESS = 'BRANDKIT_UPDATE_MEDIA_UPLOAD_PROGRESS';
export const BRANDKIT_UPLOAD_MEDIA_REQUEST = 'BRANDKIT_UPLOAD_MEDIA_REQUEST';
export const BRANDKIT_UPLOADING_MEDIA_SUCCEEDED = 'BRANDKIT_UPLOADING_MEDIA_SUCCEEDED';
export const BRANDKIT_UPLOADING_MEDIA_FAILED = 'BRANDKIT_UPLOADING_MEDIA_FAILED';
export const BRANDKIT_INVALIDATE_MEDIA_LIBRARY = 'BRANDKIT_INVALIDATE_MEDIA_LIBRARY';

export const BRANDKIT_SEARCH_MEDIA_REQUEST = 'BRANDKIT_SEARCH_MEDIA_REQUEST';
export const BRANDKIT_SEARCHING_MEDIA_SUCCEEDED = 'BRANDKIT_SEARCHING_MEDIA_SUCCEEDED';
export const BRANDKIT_SEARCHING_MEDIA_FAILED = 'BRANDKIT_SEARCHING_MEDIA_FAILED';

export const BRANDKIT_DELETE_MEDIA_REQUEST = 'BRANDKIT_DELETE_MEDIA_REQUEST';
export const BRANDKIT_DELETING_MEDIA_SUCCEEDED = 'BRANDKIT_DELETING_MEDIA_SUCCEEDED';
export const BRANDKIT_DELETING_MEDIA_FAILED = 'BRANDKIT_DELETING_MEDIA_FAILED';
export const BRANDKIT_INVALIDATE_MEDIA_DELETE_ERROR = 'BRANDKIT_INVALIDATE_MEDIA_DELETE_ERROR';

/**
 * Brandkit Icons
 */
export const BRANDKIT_TOGGLE_ICONS_LIBRARY = 'BRANDKIT_TOGGLE_ICONS_LIBRARY';
export const BRANDKIT_INITIATE_ICONS_UPLOAD = 'BRANDKIT_INITIATE_ICONS_UPLOAD';
export const BRANDKIT_INVALIDATE_ICONS_UPLOAD_ERROR = 'BRANDKIT_INVALIDATE_ICONS_UPLOAD_ERROR';
export const BRANDKIT_UPDATE_ICONS_UPLOAD_PROGRESS = 'BRANDKIT_UPDATE_ICONS_UPLOAD_PROGRESS';
export const BRANDKIT_UPLOAD_ICONS_REQUEST = 'BRANDKIT_UPLOAD_ICONS_REQUEST';
export const BRANDKIT_UPLOADING_ICONS_SUCCEEDED = 'BRANDKIT_UPLOADING_ICONS_SUCCEEDED';
export const BRANDKIT_UPLOADING_ICONS_FAILED = 'BRANDKIT_UPLOADING_ICONS_FAILED';
export const BRANDKIT_INVALIDATE_ICONS_LIBRARY = 'BRANDKIT_INVALIDATE_ICONS_LIBRARY';

export const BRANDKIT_SEARCH_ICONS_REQUEST = 'BRANDKIT_SEARCH_ICONS_REQUEST';
export const BRANDKIT_SEARCHING_ICONS_SUCCEEDED = 'BRANDKIT_SEARCHING_ICONS_SUCCEEDED';
export const BRANDKIT_SEARCHING_ICONS_FAILED = 'BRANDKIT_SEARCHING_ICONS_FAILED';

export const BRANDKIT_DELETE_ICONS_REQUEST = 'BRANDKIT_DELETE_ICONS_REQUEST';
export const BRANDKIT_DELETING_ICONS_SUCCEEDED = 'BRANDKIT_DELETING_ICONS_SUCCEEDED';
export const BRANDKIT_DELETING_ICONS_FAILED = 'BRANDKIT_DELETING_ICONS_FAILED';
export const BRANDKIT_INVALIDATE_ICONS_DELETE_ERROR = 'BRANDKIT_INVALIDATE_ICONS_DELETE_ERROR';

/**
 * Brandkit Color
 */

export const CREATE_BRANDKIT_COLOR = 'CREATE_BRANDKIT_COLOR';
export const DELETE_BRANDKIT_COLOR = 'DELETE_BRANDKIT_COLOR';
export const UPDATE_BRANDKIT_COLOR_PROPERTY = 'UPDATE_BRANDKIT_COLOR_PROPERTY';
export const RENAME_BRANDKIT_COLORS = 'RENAME_BRANDKIT_COLORS'
export const INVALIDATE_BRANDKIT_COLORS = 'INVALIDATE_BRANDKIT_COLORS';

export const FETCHING_BRANDKIT_COLORS_REQUEST = 'FETCHING_BRANDKIT_COLORS_REQUEST';
export const FETCHING_BRANDKIT_COLORS_SUCCEEDED = 'FETCHING_BRANDKIT_COLORS_SUCCEEDED';
export const FETCHING_BRANDKIT_COLORS_FAILED = 'FETCHING_BRANDKIT_COLORS_FAILED';

export const DELETE_BRANDKIT_COLORS_REQUEST = 'DELETE_BRANDKIT_COLORS_REQUEST';
export const DELETING_BRANDKIT_COLORS_SUCCEEDED = 'DELETING_BRANDKIT_COLORS_SUCCEEDED';
export const DELETING_BRANDKIT_COLORS_FAILED = 'DELETING_BRANDKIT_COLORS_FAILED';

export const UPDATE_BRANDKIT_COLORS_REQUEST = 'UPDATE_BRANDKIT_COLORS_REQUEST';
export const UPDATING_BRANDKIT_COLORS_SUCCEEDED = 'UPDATING_BRANDKIT_COLORS_SUCCEEDED';
export const UPDATING_BRANDKIT_COLORS_FAILED = 'UPDATING_BRANDKIT_COLORS_FAILED';

/**
 * Brandkit Fonts
*/
export const FETCH_BRANDKIT_FONTS_REQUEST = 'FETCH_BRANDKIT_FONTS_REQUEST';
export const FETCHING_BRANDKIT_FONTS_SUCCEEDED = 'FETCHING_BRANDKIT_FONTS_SUCCEEDED';
export const FETCHING_BRANDKIT_FONTS_FAILED = 'FETCHING_BRANDKIT_FONTS_FAILED';

export const INITIATE_BRANDKIT_FONT_UPLOAD = 'INITIATE_BRANDKIT_FONT_UPLOAD';
export const UPDATE_BRANDKIT_FONT_UPLOAD_PROGRESS = 'UPDATE_BRANDKIT_FONT_UPLOAD_PROGRESS';
export const INSTALL_BRANDKIT_FONTS = 'INSTALL_BRANDKIT_FONTS';
export const UNINSTALL_BRANDKIT_FONTS = 'UNINSTALL_BRANDKIT_FONTS';
export const INVALIDATE_BRANDKIT_FONT_UPLOAD_ERROR = 'INVALIDATE_BRANDKIT_FONT_UPLOAD_ERROR';

export const UPLOAD_BRANDKIT_FONT_REQUEST = 'UPLOAD_BRANDKIT_FONT_REQUEST';
export const UPLOADING_BRANDKIT_FONT_SUCCEEDED = 'UPLOADING_BRANDKIT_FONT_SUCCEEDED';
export const UPLOADING_BRANDKIT_FONT_FAILED = 'UPLOADING_BRANDKIT_FONT_FAILED';

export const DELETE_BRANDKIT_FONT_REQUEST = 'DELETE_BRANDKIT_FONT_REQUEST';
export const DELETING_BRANDKIT_FONT_SUCCEEDED = 'DELETING_BRANDKIT_FONT_SUCCEEDED';
export const DELETING_BRANDKIT_FONT_FAILED = 'DELETING_BRANDKIT_FONT_FAILED';

/**
 * Brandkit Text
*/
export const CREATE_BRANDKIT_TEXT = 'CREATE_BRANDKIT_TEXT';
export const DELETE_BRANDKIT_TEXT = 'DELETE_BRANDKIT_TEXT';
export const UPDATE_BRANDKIT_TEXT_PROPERTY = 'UPDATE_BRANDKIT_TEXT_PROPERTY';
export const UPDATE_BRANDKIT_TEXT_CONTENT = 'UPDATE_BRANDKIT_TEXT_CONTENT';
export const RENAME_BRANDKIT_TEXT = 'RENAME_BRANDKIT_TEXT';
export const INVALIDATE_BRANDKIT_TEXT = 'INVALIDATE_BRANDKIT_TEXT';
export const ASSOCIATE_FONTS_WITH_BRANDKIT_TEXT = 'ASSOCIATE_FONTS_WITH_BRANDKIT_TEXT';

export const FETCHING_BRANDKIT_TEXT_REQUEST = 'FETCHING_BRANDKIT_TEXT_REQUEST';
export const FETCHING_BRANDKIT_TEXT_SUCCEEDED = 'FETCHING_BRANDKIT_TEXT_SUCCEEDED';
export const FETCHING_BRANDKIT_TEXT_FAILED = 'FETCHING_BRANDKIT_TEXT_FAILED';

export const DELETE_BRANDKIT_TEXT_REQUEST = 'DELETE_BRANDKIT_TEXT_REQUEST';
export const DELETING_BRANDKIT_TEXT_SUCCEEDED = 'DELETING_BRANDKIT_TEXT_SUCCEEDED';
export const DELETING_BRANDKIT_TEXT_FAILED = 'DELETING_BRANDKIT_TEXT_FAILED';

export const UPDATE_BRANDKIT_TEXT_REQUEST = 'UPDATE_BRANDKIT_TEXT_REQUEST';
export const UPDATING_BRANDKIT_TEXT_SUCCEEDED = 'UPDATING_BRANDKIT_TEXT_SUCCEEDED';
export const UPDATING_BRANDKIT_TEXT_FAILED = 'UPDATING_BRANDKIT_TEXT_FAILED';


/**
 * Brandkit Button
 */

export const CREATE_BRANDKIT_BUTTON = 'CREATE_BRANDKIT_BUTTON';
export const DELETE_BRANDKIT_BUTTON = 'DELETE_BRANDKIT_BUTTON';
export const UPDATE_BRANDKIT_BUTTON_PROPERTY = 'UPDATE_BRANDKIT_BUTTON_PROPERTY';
export const UPDATE_BRANDKIT_BUTTON_CONTENT = 'UPDATE_BRANDKIT_BUTTON_CONTENT';
export const RENAME_BRANDKIT_BUTTON = 'RENAME_BRANDKIT_BUTTON';
export const INVALIDATE_BRANDKIT_BUTTON = 'INVALIDATE_BRANDKIT_BUTTON';
export const ASSOCIATE_FONTS_WITH_BRANDKIT_BUTTON = 'ASSOCIATE_FONTS_WITH_BRANDKIT_BUTTON';

export const FETCHING_BRANDKIT_BUTTONS_REQUEST = 'FETCHING_BRANDKIT_BUTTONS_REQUEST';
export const FETCHING_BRANDKIT_BUTTONS_SUCCEEDED = 'FETCHING_BRANDKIT_BUTTONS_SUCCEEDED';
export const FETCHING_BRANDKIT_BUTTONS_FAILED = 'FETCHING_BRANDKIT_BUTTONS_FAILED';

export const DELETE_BRANDKIT_BUTTONS_REQUEST = 'DELETE_BRANDKIT_BUTTONS_REQUEST';
export const DELETING_BRANDKIT_BUTTONS_SUCCEEDED = 'DELETING_BRANDKIT_BUTTONS_SUCCEEDED';
export const DELETING_BRANDKIT_BUTTONS_FAILED = 'DELETING_BRANDKIT_BUTTONS_FAILED';

export const UPDATE_BRANDKIT_BUTTONS_REQUEST = 'UPDATE_BRANDKIT_BUTTONS_REQUEST';
export const UPDATING_BRANDKIT_BUTTONS_SUCCEEDED = 'UPDATING_BRANDKIT_BUTTONS_SUCCEEDED';
export const UPDATING_BRANDKIT_BUTTONS_FAILED = 'UPDATING_BRANDKIT_BUTTONS_FAILED';

/**
 * Brandkit Component
 */

export const CREATE_BRANDKIT_COMPONENT_REQUEST = 'CREATE_BRANDKIT_COMPONENT_REQUEST';
export const CREATING_BRANDKIT_COMPONENT_SUCCEEDED = 'CREATING_BRANDKIT_COMPONENT_SUCCEEDED';
export const CREATING_BRANDKIT_COMPONENT_FAILED = 'CREATING_BRANDKIT_COMPONENT_FAILED';

export const FETCHING_PALETTE_COMPONENT_EDITOR_REQUEST = 'FETCHING_PALETTE_COMPONENT_EDITOR_REQUEST';
export const FETCHING_PALETTE_COMPONENT_EDITOR_SUCCEEDED = 'FETCHING_PALETTE_COMPONENT_EDITOR_SUCCEEDED';
export const FETCHING_PALETTE_COMPONENT_EDITOR_FAILED = 'FETCHING_PALETTE_COMPONENT_EDITOR_FAILED';

export const INVALIDATE_PALETTE_COMPONENT = 'INVALIDATE_PALETTE_COMPONENT';
export const INVALIDATE_BRANDKIT_COMPONENT = 'INVALIDATE_BRANDKIT_COMPONENT';

export const DELETE_BRANDKIT_COMPONENT = 'DELETE_BRANDKIT_COMPONENT';
export const UPDATE_BRANDKIT_COMPONENT_PROPERTY = 'UPDATE_BRANDKIT_COMPONENT_PROPERTY';
export const UPDATE_BRANDKIT_COMPONENT_CONTENT = 'UPDATE_BRANDKIT_COMPONENT_CONTENT';
export const RENAME_BRANDKIT_COMPONENT = 'RENAME_BRANDKIT_COMPONENT';
export const RENAME_PALETTE_COMPONENT_REQUEST = 'RENAME_PALETTE_COMPONENT_REQUEST';
export const ASSOCIATE_FONTS_WITH_BRANDKIT_COMPONENT = 'ASSOCIATE_FONTS_WITH_BRANDKIT_COMPONENT';

export const FETCHING_BRANDKIT_COMPONENTS_REQUEST = 'FETCHING_BRANDKIT_COMPONENTS_REQUEST';
export const FETCHING_BRANDKIT_COMPONENTS_SUCCEEDED = 'FETCHING_BRANDKIT_COMPONENTS_SUCCEEDED';
export const FETCHING_BRANDKIT_COMPONENTS_FAILED = 'FETCHING_BRANDKIT_COMPONENTS_FAILED';

export const UPDATE_PALETTE_COMPONENT_REQUEST = 'UPDATE_PALETTE_COMPONENT_REQUEST';
export const UPDATING_PALETTE_COMPONENT_SUCCEEDED = 'UPDATING_PALETTE_COMPONENT_SUCCEEDED';
export const UPDATING_PALETTE_COMPONENT_FAILED = 'UPDATING_PALETTE_COMPONENT_FAILED';

export const PUBLISH_PALETTE_COMPONENT_REQUEST = "PUBLISH_PALETTE_COMPONENT_REQUEST";
export const PUBLISHING_PALETTE_COMPONENT_SUCCEEDED = "PUBLISHING_PALETTE_COMPONENT_SUCCEEDED";
export const PUBLISHING_PALETTE_COMPONENT_FAILED = "PUBLISHING_PALETTE_COMPONENT_FAILED";

export const DELETE_BRANDKIT_COMPONENTS_REQUEST = 'DELETE_BRANDKIT_COMPONENTS_REQUEST';
export const DELETING_BRANDKIT_COMPONENTS_SUCCEEDED = 'DELETING_BRANDKIT_COMPONENTS_SUCCEEDED';
export const DELETING_BRANDKIT_COMPONENTS_FAILED = 'DELETING_BRANDKIT_COMPONENTS_FAILED';

export const UPDATE_BRANDKIT_COMPONENTS_REQUEST = 'UPDATE_BRANDKIT_COMPONENTS_REQUEST';
export const UPDATING_BRANDKIT_COMPONENTS_SUCCEEDED = 'UPDATING_BRANDKIT_COMPONENTS_SUCCEEDED';
export const UPDATING_BRANDKIT_COMPONENTS_FAILED = 'UPDATING_BRANDKIT_COMPONENTS_FAILED';

export const RELOAD_PALETTE_COMPONENT_ON_CHANGE = "RELOAD_PALETTE_COMPONENT_ON_CHANGE";
export const RELOAD_EDITOR_PALETTE_COMPONENT_SUCCEEDED = "RELOAD_EDITOR_PALETTE_COMPONENT_SUCCEEDED";
export const RELOAD_EDITOR_BRAND_COMPONENT_SUCCEEDED = 'RELOAD_EDITOR_BRAND_COMPONENT_SUCCEEDED';

/**
 * Editor Brandkit Actions
*/
export const CREATE_EDITOR_BRAND_MEDIA_REQUEST = 'CREATE_EDITOR_BRAND_MEDIA_REQUEST';
export const CREATING_EDITOR_BRAND_MEDIA_SUCCEEDED = 'CREATING_EDITOR_BRAND_MEDIA_SUCCEEDED';
export const CREATING_EDITOR_BRAND_MEDIA_FAILED = 'CREATING_EDITOR_BRAND_MEDIA_FAILED';

export const CREATE_EDITOR_BRAND_COMPONENT_REQUEST = 'CREATE_EDITOR_BRAND_COMPONENT_REQUEST';
export const CREATING_EDITOR_BRAND_COMPONENT_SUCCEEDED = 'CREATING_EDITOR_BRAND_COMPONENT_SUCCEEDED';
export const CREATING_EDITOR_BRAND_COMPONENT_FAILED = 'CREATING_EDITOR_BRAND_COMPONENT_FAILED';

export const INVALIDATE_BRAND_ELEMENTS = 'INVALIDATE_BRAND_ELEMENTS';

/**
 * Palette Actions
 */
export const FETCH_PALETTES_REQUEST = 'FETCH_PALETTES_REQUEST';
export const FETCH_PALETTES_SUCCEEDED = 'FETCH_PALETTES_SUCCEEDED';
export const FETCH_PALETTES_FAILED = 'FETCH_PALETTES_FAILED';

export const FETCH_PALETTES_FOR_WORKSPACE_REQUEST = 'FETCH_PALETTES_FOR_WORKSPACE_REQUEST';
export const FETCH_PALETTES_FOR_WORKSPACE_SUCCEEDED = 'FETCH_PALETTES_FOR_WORKSPACE_SUCCEEDED';
export const FETCH_PALETTES_FOR_WORKSPACE_FAILED = 'FETCH_PALETTES_FOR_WORKSPACE_FAILED';

export const FETCH_PALETTE_FOLDERS_REQUEST = 'FETCH_PALETTE_FOLDERS_REQUEST';
export const FETCH_PALETTE_FOLDERS_SUCCEEDED = 'FETCH_PALETTE_FOLDERS_SUCCEEDED';
export const FETCH_PALETTE_FOLDERS_FAILED = 'FETCH_PALETTE_FOLDERS_FAILED';

export const FETCH_COMPONENTS_FOR_PALETTE_REQUEST = 'FETCH_COMPONENTS_FOR_PALETTE_REQUEST';
export const FETCH_COMPONENTS_FOR_PALETTE_SUCCEEDED = 'FETCH_COMPONENTS_FOR_PALETTE_SUCCEEDED';
export const FETCH_COMPONENTS_FOR_PALETTE_FAILED = 'FETCH_COMPONENTS_FOR_PALETTE_FAILED';

export const FETCH_COMPONENTS_FOR_PALETTE_FOLDER_REQUEST = 'FETCH_COMPONENTS_FOR_PALETTE_FOLDER_REQUEST';
export const FETCH_COMPONENTS_FOR_PALETTE_FOLDER_SUCCEEDED = 'FETCH_COMPONENTS_FOR_PALETTE_FOLDER_SUCCEEDED';
export const FETCH_COMPONENTS_FOR_PALETTE_FOLDER_FAILED = 'FETCH_COMPONENTS_FOR_PALETTE_FOLDER_FAILED';

export const FETCH_MEDIA_FOR_PALETTE_REQUEST = 'FETCH_MEDIA_FOR_PALETTE_REQUEST';
export const FETCH_MEDIA_FOR_PALETTE_SUCCEEDED = 'FETCH_MEDIA_FOR_PALETTE_SUCCEEDED';
export const FETCH_MEDIA_FOR_PALETTE_FAILED = 'FETCH_MEDIA_FOR_PALETTE_FAILED';

/*
  Integrartions Actions
*/
export const FETCHING_INTEGRATIONS_REQUEST = "FETCHING_INTEGRATIONS_REQUEST";
export const FETCHING_INTEGRATIONS_SUCCEDDED = "FETCHING_INTEGRATIONS_SUCCEDDED";
export const FETCHING_INTEGRATIONS_FAILED = "FETCHING_INTEGRATIONS_FAILED";
export const INVALIDATE_INTEGRATIONS = "INVALIDATE_INTEGRATIONS";

export const ACTIVATING_INTEGRATION_SUCCEDDED = "ACTIVATING_INTEGRATION_SUCCEDDED";

export const DEACTIVATING_INTEGRATION_REQUEST = "DEACTIVATING_INTEGRATION_REQUEST";
export const DEACTIVATING_INTEGRATION_SUCCEDDED = "DEACTIVATING_INTEGRATION_SUCCEDDED";
export const DEACTIVATING_INTEGRATION_FAILED = "DEACTIVATING_INTEGRATION_FAILED";

export const INTEGRATION_AUTH_EXPIRED = "INTEGRATION_AUTH_EXPIRED";

//hubspot Integration Actions
export const AUTHENTICATE_HUBSPOT_REQUEST = "AUTHENTICATE_HUBSPOT_REQUEST";
export const AUTHENTICATE_HUBSPOT_SUCCEDDED = "AUTHENTICATE_HUBSPOT_SUCCEDDED";
export const AUTHENTICATE_HUBSPOT_FAILED = "AUTHENTICATE_HUBSPOT_FAILED";

export const UPDATE_HUBSPOT_REQUEST = "UPDATE_HUBSPOT_REQUEST";
export const UPDATING_HUBSPOT_SUCCEEDED = "UPDATING_HUBSPOT_SUCCEEDED";
export const UPDATING_HUBSPOT_FAILED = "UPDATING_HUBSPOT_FAILED";

export const FETCH_HUBSPOT_FORMS = 'FETCH_HUBSPOT_FORMS';
export const FETCHING_HUBSPOT_FORMS_SUCCEEDED = 'FETCHING_HUBSPOT_FORMS_SUCCEEDED';
export const FETCHING_HUBSPOT_FORMS_FAILED = 'FETCHING_HUBSPOT_FORMS_FAILED';

export const FETCH_HUBSPOT_FORM = 'FETCH_HUBSPOT_FORM';
export const FETCHING_HUBSPOT_FORM_SUCCEEDED = 'FETCHING_HUBSPOT_FORM_SUCCEEDED';
export const FETCHING_HUBSPOT_FORM_FAILED = 'FETCHING_HUBSPOT_FORM_FAILED';

/*
  Marketo Integrartions Actions
*/
export const AUTHENTICATE_MARKETO_REQUEST = 'AUTHENTICATE_MARKETO_REQUEST';
export const AUTHENTICATE_MARKETO_SUCCEEDED = 'AUTHENTICATE_MARKETO_SUCCEEDED';
export const AUTHENTICATE_MARKETO_FAILED = 'AUTHENTICATE_MARKETO_FAILED';

export const FETCH_MARKETO_FORMS = 'FETCH_MARKETO_FORMS';
export const FETCHING_MARKETO_FORMS_SUCCEEDED = 'FETCHING_MARKETO_FORMS_SUCCEEDED';
export const FETCHING_MARKETO_FORMS_FAILED = 'FETCHING_MARKETO_FORMS_FAILED';

export const SEARCH_MARKETO_FORM = 'SEARCH_MARKETO_FORM';
export const SEARCH_MARKETO_FORM_SUCCEEDED = 'SEARCH_MARKETO_FORM_SUCCEEDED';
export const SEARCH_MARKETO_FORM_FAILED = 'SEARCH_MARKETO_FORM_FAILED';


/*
  Pardot Integrartions Actions
*/
export const AUTHENTICATE_PARDOT_REQUEST = 'AUTHENTICATE_PARDOT_REQUEST';
export const AUTHTENTICATING_PARDOT_SUCCEEDED = 'AUTHTENTICATING_PARDOT_SUCCEEDED';
export const AUTHTENTICATING_PARDOT_FAILED = 'AUTHTENTICATING_PARDOT_FAILED';

export const UPDATE_PARDOT_REQUEST = 'UPDATE_PARDOT_REQUEST';
export const UPDATING_PARDOT_SUCCEEDED = 'UPDATING_PARDOT_SUCCEEDED';
export const UPDATING_PARDOT_FAILED = 'UPDATING_PARDOT_FAILED';

export const FETCH_PARDOT_FORMS = 'FETCH_PARDOT_FORMS';
export const FETCHING_PARDOT_FORMS_SUCCEEDED = 'FETCHING_PARDOT_FORMS_SUCCEEDED';
export const FETCHING_PARDOT_FORMS_FAILED = 'FETCHING_PARDOT_FORMS_FAILED';

export const FETCH_PARDOT_FORM = 'FETCH_PARDOT_FORM';
export const FETCHING_PARDOT_FORM_SUCCEEDED = 'FETCHING_PARDOT_FORM_SUCCEEDED';
export const FETCHING_PARDOT_FORM_FAILED = 'FETCHING_PARDOT_FORM_FAILED';

export const DEACTIVATE_PARDOT_REQUEST = 'DEACTIVATE_PARDOT_REQUEST';
export const DEACTIVATING_PARDOT_SUCCEEDED = 'DEACTIVATING_PARDOT_SUCCEEDED';
export const DEACTIVATING_PARDOT_FAILED = 'DEACTIVATING_PARDOT_FAILED';

/*
  Salesforce Integrations Actions
*/
export const AUTHENTICATE_SALESFORCE_REQUEST = 'AUTHENTICATE_SALESFORCE_REQUEST';
export const AUTHTENTICATING_SALESFORCE_SUCCEEDED = 'AUTHTENTICATING_SALESFORCE_SUCCEEDED';
export const AUTHTENTICATING_SALESFORCE_FAILED = 'AUTHTENTICATING_SALESFORCE_FAILED';

export const UPDATE_SALESFORCE_REQUEST = 'UPDATE_SALESFORCE_REQUEST';
export const UPDATING_SALESFORCE_SUCCEEDED = 'UPDATING_SALESFORCE_SUCCEEDED';
export const UPDATING_SALESFORCE_FAILED = 'UPDATING_SALESFORCE_FAILED';

/*
  Zoho Integration Actions
*/

export const AUTHENTICATE_ZOHO_REQUEST = 'AUTHENTICATE_ZOHO_REQUEST';
export const AUTHTENTICATING_ZOHO_SUCCEEDED = 'AUTHTENTICATING_ZOHO_SUCCEEDED';
export const AUTHTENTICATING_ZOHO_FAILED = 'AUTHTENTICATING_ZOHO_FAILED';

export const UPDATE_ZOHO_REQUEST = 'UPDATE_ZOHO_REQUEST';
export const UPDATING_ZOHO_SUCCEEDED = 'UPDATING_ZOHO_SUCCEEDED';
export const UPDATING_ZOHO_FAILED = 'UPDATING_ZOHO_FAILED';

/*
  Figma Integrations Actions
*/
export const AUTHENTICATE_FIGMA_REQUEST = 'AUTHENTICATE_FIGMA_REQUEST';
export const AUTHTENTICATING_FIGMA_SUCCEEDED = 'AUTHTENTICATING_FIGMA_SUCCEEDED';
export const AUTHTENTICATING_FIGMA_FAILED = 'AUTHTENTICATING_FIGMA_FAILED';

export const FETCH_FIGMA_FRAMES_REQUEST = 'FETCH_FIGMA_FRAMES_REQUEST';
export const FETCHING_FIGMA_FRAMES_SUCCEEDED = 'FETCHING_FIGMA_FRAMES_SUCCEEDED';
export const FETCHING_FIGMA_FRAMES_FAILED = 'FETCHING_FIGMA_FRAMES_FAILED';

export const UPDATE_FIGMA_SELECTION = 'UPDATE_FIGMA_SELECTION';

export const INVALIDATE_FIGMA = 'INVALIDATE_FIGMA';

/*
  Paperflite Integrartions Actions
*/

export const FETCHING_HUB_STREAMS_REQUEST = 'FETCHING_HUB_STREAMS_REQUEST';
export const FETCHING_HUB_STREAMS_SUCCEEDED = 'FETCHING_HUB_STREAMS_SUCCEEDED';
export const FETCHING_HUB_STREAMS_FAILED = 'FETCHING_HUB_STREAMS_FAILED';

export const FETCHING_STREAM_REQUEST = 'FETCHING_STREAM_REQUEST';
export const FETCHING_STREAM_SUCCEEDED = 'FETCHING_STREAM_SUCCEEDED';
export const FETCHING_STREAM_FAILED = 'FETCHING_STREAM_FAILED';

export const FETCHING_GROUP_REQUEST = 'FETCHING_GROUP_REQUEST';
export const FETCHING_GROUP_SUCCEEDED = 'FETCHING_GROUP_SUCCEEDED';
export const FETCHING_GROUP_FAILED = 'FETCHING_GROUP_FAILED';

export const UPLOAD_ASSET_REQUEST = 'UPLOAD_ASSET_REQUEST';
export const DELETE_ASSET_REQUEST = 'DELETE_ASSET_REQUEST';


export const INVALIDATE_STREAM = 'INVALIDATE_STREAM';
export const INVALIDATE_GROUP = 'INVALIDATE_GROUP';


/**
 * Content upload
 */
export const UPLOAD_CONTENT_REQUEST = 'UPLOAD_CONTENT_REQUEST';
export const UPLOADING_CONTENT_SUCCEDDED = 'UPLOADING_CONTENT_SUCCEDDED';
export const UPLOADING_CONTENT_FAILED = 'UPLOADING_CONTENT_FAILED';
export const UPLOADING_CONTENT_PROGRESS = 'UPLOADING_CONTENT_PROGRESS';

export const CREATE_CONTENT_REQUEST = 'CREATE_CONTENT_REQUEST';
export const CREATING_CONTENT_SUCCEEDED = 'CREATING_CONTENT_SUCCEEDED';
export const CREATING_CONTENT_FAILED = 'CREATING_CONTENT_FAILED';

export const UPDATE_ASSETS_CONTENT = 'UPDATE_ASSETS_CONTENT';
export const UPDATE_MULTIPLE_ASSETS_CONTENT = 'UPDATE_MULTIPLE_ASSETS_CONTENT'

export const CREATE_ASSET_MAPPING_REQUEST = 'CREATE_ASSET_MAPPING_REQUEST';
export const CREATING_ASSET_MAPPING_SUCCEEDED = 'CREATING_ASSET_MAPPING_SUCCEEDED';
export const CREATING_ASSET_MAPPING_FAILED = 'CREATING_ASSET_MAPPING_FAILED';

export const UPDATE_ASSET_MAPPING_REQUEST = 'UPDATE_ASSET_MAPPING_REQUEST';
export const UPDATING_ASSET_MAPPING_SUCCEEDED = 'UPDATING_ASSET_MAPPING_SUCCEEDED';
export const UPDATING_ASSET_MAPPING_FAILED = 'UPDATING_ASSET_MAPPING_FAILED';

export const UPDATE_ASSET_MAPPINGS_REQUEST = 'UPDATE_ASSET_MAPPINGS_REQUEST'
export const UPDATING_ASSET_MAPPINGS_SUCCEEDED = 'UPDATING_ASSET_MAPPINGS_SUCCEEDED';
export const UPDATING_ASSET_MAPPINGS_FAILED = 'UPDATING_ASSET_MAPPINGS_FAILED';

export const DELETE_ASSET_MAPPINGS_GATING_REQUEST = 'DELETE_ASSET_MAPPINGS_GATING_REQUEST';
export const DELETING_ASSET_MAPPINGS_GATING_SUCCEEDED = 'DELETING_ASSET_MAPPINGS_GATING_SUCCEEDED';
export const DELETING_ASSET_MAPPINGS_GATING_FAILED = 'DELETING_ASSET_MAPPINGS_GATING_FAILED';

export const FETCH_ASSET_MAPPINGS_REQUEST = 'FETCH_ASSET_MAPPINGS_REQUEST';
export const FETCHING_ASSET_MAPPINGS_SUCCEEDED = 'FETCHING_ASSET_MAPPINGS_SUCCEEDED';
export const FETCHING_ASSET_MAPPINGS_FAILED = 'FETCHING_ASSET_MAPPINGS_FAILED';

export const FETCH_ASSET_MAPPING_REQUEST = 'FETCH_ASSET_MAPPING_REQUEST';
export const FETCHING_ASSET_MAPPING_SUCCEEDED = 'FETCHING_ASSET_MAPPING_SUCCEEDED';
export const FETCHING_ASSET_MAPPING_FAILED = 'FETCHING_ASSET_MAPPING_FAILED';

export const DELETE_ASSET_MAPPINGS_REQUEST = 'DELETE_ASSET_MAPPINGS_REQUEST';
export const DELETING_ASSET_MAPPINGS_SUCCEEDED = 'DELETING_ASSET_MAPPINGS_SUCCEEDED';
export const DELETING_ASSET_MAPPINGS_FAILED = 'DELETING_ASSET_MAPPINGS_FAILED';

export const INVALIDATE_ASSET_MAPPINGS = 'INVALIDATE_ASSET_MAPPINGS';

export const UPDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER = 'UPDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER';
export const INVALIDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER = 'INVALIDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER';

export const FETCH_ASSET_MAPPINGS_ON_SEARCH_REQUEST = 'FETCH_ASSET_MAPPINGS_ON_SEARCH_REQUEST';
export const FETCHING_ASSET_MAPPINGS_ON_SEARCH_SUCCEEDED = 'FETCHING_ASSET_MAPPINGS_ON_SEARCH_SUCCEEDED';
export const FETCHING_ASSET_MAPPINGS_ON_SEARCH_FAILED = 'FETCHING_ASSET_MAPPINGS_ON_SEARCH_FAILED';
export const INVALIDATE_SEARCH_ASSET_MAPPINGS = 'INVALIDATE_SEARCH_ASSET_MAPPINGS';

export const REMOVE_ASSET_REQUEST = 'REMOVE_ASSET_REQUEST';
export const INVALIDATE_ASSET_SELECTION = 'INVALIDATE_ASSET_SELECTION';

/**
 * Duplicate Asset url
 */
export const FETCH_DUPLICATE_ASSETS_REQUEST = 'FETCH_DUPLICATE_ASSETS_REQUEST';
export const FETCHING_DUPLICATE_ASSETS_SUCCEEDED = 'FETCHING_DUPLICATE_ASSETS_SUCCEEDED';
export const FETCHING_DUPLICATE_ASSETS_FAILED = 'FETCHING_DUPLICATE_ASSETS_FAILED';

export const INVALIDATE_DUPLICATE_ASSETS = 'INVALIDATE_DUPLICATE_ASSETS';

/**
 * Content upload url
 */
export const ADD_ASSET_URL = 'ADD_ASSET_URL';
export const ADD_ASSET_URL_SUCCEDDED = 'ADD_ASSET_URL_SUCCEDDED';
export const ADD_ASSET_URL_FAILED = 'ADD_ASSET_URL_FAILED';
export const INVALIDATE_ASSET_UPLOADED = 'INVALIDATE_ASSET_UPLOADED';

export const CREATE_ASSET_VERSION_REQUEST = 'CREATE_ASSET_VERSION_REQUEST';
export const CREATING_ASSET_VERSION_SUCCEEDED = 'CREATING_ASSET_VERSION_SUCCEEDED';
export const CREATING_ASSET_VERSION_FAILED = 'CREATING_ASSET_VERSION_FAILED';
export const UPLOADING_ASSET_VERSION_PROGRESS = 'UPLOADING_ASSET_VERSION_PROGRESS';
export const UPLOADING_ASSET_VERSION_STARTED = 'UPLOADING_ASSET_VERSION_STARTED';



/*
  Websocket message
*/
export const WS_ASSET_PROCESSED = "WS_ASSET_PROCESSED";

/**
 * Storyboard Reports
 */
export const FETCHING_STORYBOARD_REPORT_SUMMARY = 'FETCHING_STORYBOARD_REPORT_SUMMARY';
export const FETCHING_STORYBOARD_REPORT_SUMMARY_SUCCEEDED = 'FETCHING_STORYBOARD_REPORT_SUMMARY_SUCCEEDED';
export const FETCHING_STORYBOARD_REPORT_SUMMARY_FAILED = 'FETCHING_STORYBOARD_REPORT_SUMMARY_FAILED';

export const FETCHING_STORYBOARD_VISITORS_REPORTS = 'FETCHING_STORYBOARD_VISITORS_REPORTS';
export const FETCHING_STORYBOARD_VISITORS_REPORTS_SUCCEEDED = 'FETCHING_STORYBOARD_VISITORS_REPORTS_SUCCEEDED';
export const FETCHING_STORYBOARD_VISITORS_REPORTS_FAILED = 'FETCHING_STORYBOARD_VISITORS_REPORTS_FAILED';

export const FETCHING_INTERACTIVE_PAGES_REPORTS = 'FETCHING_INTERACTIVE_PAGES_REPORTS';
export const FETCHING_INTERACTIVE_PAGES_REPORTS_SUCCEEDED = 'FETCHING_INTERACTIVE_PAGES_REPORTS_SUCCEEDED';
export const FETCHING_INTERACTIVE_PAGES_REPORTS_FAILED = 'FETCHING_INTERACTIVE_PAGES_REPORTS_FAILED';

export const FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS = 'FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS';
export const FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_SUCCEEDED = 'FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_SUCCEEDED';
export const FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_FAILED = 'FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_FAILED';

export const FETCHING_STORYBOARD_INTERACTIONS_REPORTS = 'FETCHING_STORYBOARD_INTERACTIONS_REPORTS';
export const FETCHING_STORYBOARD_INTERACTIONS_REPORTS_SUCCEEDED = 'FETCHING_STORYBOARD_INTERACTIONS_REPORTS_SUCCEEDED';
export const FETCHING_STORYBOARD_INTERACTIONS_REPORTS_FAILED = 'FETCHING_STORYBOARD_INTERACTIONS_REPORTS_FAILED';

export const FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES = 'FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES';
export const FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_SUCCEEDED = 'FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_SUCCEEDED';
export const FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_FAILED = 'FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_FAILED';

export const FETCHING_STORYBOARD_SESSIONS_TIME_SERIES = 'FETCHING_STORYBOARD_SESSIONS_TIME_SERIES';
export const FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_SUCCEEDED = 'FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_SUCCEEDED';
export const FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_FAILED = 'FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_FAILED';

export const FETCHING_STORYBOARD_ASSETS_ANALYTICS = 'FETCHING_STORYBOARD_ASSETS_ANALYTICS';
export const FETCHING_STORYBOARD_ASSETS_ANALYTICS_SUCCEEDED = 'FETCHING_STORYBOARD_ASSETS_ANALYTICS_SUCCEEDED';
export const FETCHING_STORYBOARD_ASSETS_ANALYTICS_FAILED = 'FETCHING_STORYBOARD_ASSETS_ANALYTICS_FAILED';

export const FETCHING_STORYBOARD_LEADS_TIME_SERIES = 'FETCHING_STORYBOARD_LEADS_TIME_SERIES';
export const FETCHING_STORYBOARD_LEADS_TIME_SERIES_SUCCEEDED = 'FETCHING_STORYBOARD_LEADS_TIME_SERIES_SUCCEEDED';
export const FETCHING_STORYBOARD_LEADS_TIME_SERIES_FAILED = 'FETCHING_STORYBOARD_LEADS_TIME_SERIES_FAILED';

export const FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS = 'FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS';
export const FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS_SUCCEEDED = 'FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS_SUCCEEDED';
export const FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS_FAILED = 'FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS_FAILED';

export const FETCHING_INTERACTIVE_DOWNLOADS_TRENDS = 'FETCHING_INTERACTIVE_DOWNLOADS_TRENDS';
export const FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_SUCCEEDED = 'FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_SUCCEEDED';
export const FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_FAILED = 'FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_FAILED';

export const FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS = 'FETCHING_STORYBOARD_UNIQUE_VISITORS_TIME_SERIES';
export const FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_SUCCEEDED = 'FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_SUCCEEDED';
export const FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_FAILED = 'FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_FAILED';
export const INVALIDATE_STORYBOARD_LEAD_DETAILS = 'INVALIDATE_STORYBOARD_LEAD_DETAILS';

export const FETCHING_JOURNEY_REPORTS = 'FETCHING_JOURNEY_REPORTS';
export const FETCHING_JOURNEY_REPORTS_SUCCEEDED = 'FETCHING_JOURNEY_REPORTS_SUCCEEDED';
export const FETCHING_JOURNEY_REPORTS_FAILED = 'FETCHING_JOURNEY_REPORTS_FAILED';

export const CHANGE_REPORT_TYPE = 'CHANGE_REPORT_TYPE';

/**
 * Lead Reports for storyboard
 */

export const FETCHING_STORYBOARD_LEAD_SUMMARY = 'FETCHING_STORYBOARD_LEAD_SUMMARY';
export const FETCHING_STORYBOARD_LEAD_SUMMARY_SUCCEEDED = 'FETCHING_STORYBOARD_LEAD_SUMMARY_SUCCEEDED';
export const FETCHING_STORYBOARD_LEAD_SUMMARY_FAILED = 'FETCHING_STORYBOARD_LEAD_SUMMARY_FAILED';

export const FETCHING_STORYBOARD_LEAD_DETAILS = 'FETCHING_STORYBOARD_LEAD_DETAILS';
export const FETCHING_STORYBOARD_LEAD_DETAILS_SUCCEEDED = 'FETCHING_STORYBOARD_LEAD_DETAILS_SUCCEEDED';
export const FETCHING_STORYBOARD_LEAD_DETAILS_FAILED = 'FETCHING_STORYBOARD_LEAD_DETAILS_FAILED';

export const FETCHING_FIRST_CAPTURED_LEAD_DETAILS = 'FETCHING_FIRST_CAPTURED_LEAD_DETAILS';
export const FETCHING_FIRST_CAPTURED_LEAD_DETAILS_SUCCEEDED = 'FETCHING_FIRST_CAPTURED_LEAD_SUCCEEDED';
export const FETCHING_FIRST_CAPTURED_LEAD_DETAILS_FAILED = 'FETCHING_FIRST_CAPTURED_LEAD_FAILED';

export const FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS = 'FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS';
export const FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_SUCCEEDED = 'FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_SUCCEEDED';
export const FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_FAILED = 'FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_FAILED';

export const FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD = 'FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD';
export const FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED = 'FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED';
export const FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_FAILED = 'FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_FAILED';

export const FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION = 'FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION';
export const FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_SUCCEEDED = 'FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_SUCCEEDED';
export const FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_FAILED = 'FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_FAILED';

export const FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD = 'FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD';
export const FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED = 'FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED';
export const FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_FAILED = 'FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_FAILED';

export const FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION = 'FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION';
export const FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_SUCCEEDED = 'FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_SUCCEEDED';
export const FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_FAILED = 'FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_FAILED';

export const FETCHING_ASSET_INTERACTION_FOR_LEAD = 'FETCHING_ASSET_INTERACTION_FOR_LEAD';
export const FETCHING_ASSET_INTERACTION_FOR_LEAD_SUCCEEDED = 'FETCHING_ASSET_INTERACTION_FOR_LEAD_SUCCEEDED';
export const FETCHING_ASSET_INTERACTION_FOR_LEAD_FAILED = 'FETCHING_ASSET_INTERACTION_FOR_LEAD_FAILED';

export const FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION = 'FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION';
export const FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_SUCCEEDED = 'FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_SUCCEEDED';
export const FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_FAILED = 'FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_FAILED';

export const FETCHING_STORYBOARD_LEAD_JOURNEY = 'FETCHING_STORYBOARD_LEAD_JOURNEY';
export const FETCHING_STORYBOARD_LEAD_JOURNEY_SUCCEEDED = 'FETCHING_STORYBOARD_LEAD_JOURNEY_SUCCEEDED';
export const FETCHING_STORYBOARD_LEAD_JOURNEY_FAILED = 'FETCHING_STORYBOARD_LEAD_JOURNEY_FAILED';

export const FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD = 'FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD';
export const FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED = 'FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED';
export const FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_FAILED = 'FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_FAILED';

export const INVALIDATE_LEADS_DOWNLOAD_DATA = 'INVALIDATE_LEADS_DOWNLOAD_DATA';


export const FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD = 'FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD';
export const FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED = 'FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED';
export const FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_FAILED = 'FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_FAILED';

/**
 * Fetch All pages for storyboard
 */
export const FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD = "FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD";
export const FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_SUCCEEDED = "FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_SUCCEEDED";
export const FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_FAILED = "FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_FAILED";

export const FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD = "FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD";
export const FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_SUCCEEDED = "FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_SUCCEEDED";
export const FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_FAILED = "FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_FAILED";

/**
 * Transactional Metrics 
 */
export const CREATE_TRANSACTIONAL_METRICS_REQUEST = 'CREATE_TRANSACTIONAL_METRICS_REQUEST';
export const CREATING_TRANSACTIONAL_METRICS_SUCCEEDED = 'CREATING_TRANSACTIONAL_METRICS_SUCCEEDED';
export const CREATING_TRANSACTIONAL_METRICS_FAILED = 'CREATING_TRANSACTIONAL_METRICS_FAILED';

/**
 * Intractive Appearances
 */
export const UPDATE_APPEARANCE_REQUEST = 'UPDATE_APPEARANCE_REQUEST';

/**
 * * Storyboard List
 */
export const CREATE_STORYBOARD_LIST_REQUEST = 'CREATE_STORYBOARD_LIST_REQUEST';
export const CREATING_STORYBOARD_LIST_SUCCEEDED = 'CREATING_STORYBOARD_LIST_SUCCEEDED';
export const CREATING_STORYBOARD_LIST_FAILED = 'CREATING_STORYBOARD_LIST_FAILED';

export const FETCH_STORYBOARD_LIST_REQUEST = 'FETCH_STORYBOARD_LIST_REQUEST';
export const FETCHING_STORYBOARD_LIST_SUCCEEDED = 'FETCHING_STORYBOARD_LIST_SUCCEEDED';
export const FETCHING_STORYBOARD_LIST_FAILED = 'FETCHING_STORYBOARD_LIST_FAILED';

export const UPDATING_STORYBOARD_LIST_REQUEST = "UPDATING_STORYBOARD_LIST_REQUEST";
export const UPDATING_STORYBOARD_LIST_SUCCEEDED = 'UPDATING_STORYBOARD_LIST_SUCCEEDED';
export const UPDATING_STORYBOARD_LIST_FAILED = 'UPDATING_STORYBOARD_LIST_FAILED';

export const ADDING_STORYBOARD_TO_LIST_REQUEST = "ADDING_STORYBOARD_TO_LIST_REQUEST";
export const ADDING_STORYBOARD_TO_LIST_SUCCEEDED = 'ADDING_STORYBOARD_TO_LIST_SUCCEEDED';
export const ADDING_STORYBOARD_TO_LIST_FAILED = 'ADDING_STORYBOARD_TO_LIST_FAILED';

export const DELETE_STORYBOARD_LIST_REQUEST = "DELETE_STORYBOARD_LIST_REQUEST";
export const DELETING_STORYBOARD_LIST_SUCCEEDED = "DELETING_STORYBOARD_LIST_SUCCEEDED";
export const DELETING_STORYBOARD_LIST_FAILED = "DELETING_STORYBOARD_LIST_FAILED";

export const SHOW_STORYBOARD_LIST_CREATE_FORM = "SHOW_STORYBOARD_LIST_CREATE_FORM";
export const INVALIDATE_STORYBOARD_LIST = "INVALIDATE_STORYBOARD_LIST";
export const INVALIDATE_ADD_STORYBOARD = "INVALIDATE_ADD_STORYBOARD";

export const SELECT_STORYBOARD_LIST = "SELECT_STORYBOARD_LIST";

export const REMOVING_STORYBOARD_FROM_LIST = 'REMOVING_STORYBOARD_FROM_LIST';
export const REMOVING_STORYBOARD_FROM_LIST_SUCCEEDED = 'REMOVING_STORYBOARD_FROM_LIST_SUCCEEDED';
export const REMOVING_STORYBOARD_FROM_LIST_FAILED = 'REMOVING_STORYBOARD_FROM_LIST_FAILED';


/**
 * Content grid
 */
export const CREATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST = 'CREATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST';
export const CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED = 'CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED';
export const CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED = 'CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED';

export const UPDATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST = 'UPDATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST';
export const UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED = 'UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED';
export const UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED = 'UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED';

export const FETCH_MAPPINGS_FOR_CONTENT_GRID_REQUEST = 'FETCH_MAPPINGS_FOR_CONTENT_GRID_REQUEST';
export const FETCHING_MAPPINGS_FOR_CONTENT_GRID_SUCCEEDED = 'FETCHING_MAPPINGS_FOR_CONTENT_GRID_SUCCEEDED';
export const FETCHING_MAPPINGS_FOR_CONTENT_GRID_FAILED = 'FETCHING_MAPPINGS_FOR_CONTENT_GRID_FAILED';

export const UPDATE_LAYOUT_MANAGER_REQUEST = 'UPDATE_LAYOUT_MANAGER_REQUEST';
export const UPDATING_LAYOUT_MANAGER_SUCCEEDED = 'UPDATING_LAYOUT_MANAGER_SUCCEEDED';
export const UPDATING_LAYOUT_MANAGER_FAILED = 'UPDATING_LAYOUT_MANAGER_FAILED';

export const FETCH_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST = 'FETCH_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST';
export const FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED = 'FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED';
export const FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED = 'FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED';

export const FETRCH_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST = 'FETRCH_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST';
export const FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED = 'FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED';
export const FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED = 'FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED';

export const UPDATE_DYNAMIC_LAYOUT_MANAGER = 'UPDATE_DYNAMIC_LAYOUT_MANAGER';
export const UPDATE_FILTERS_FOR_LAYOUT_MAMNAGER = 'UPDATE_FILTERS_FOR_LAYOUT_MAMNAGER';
export const UPDATE_SORT_FOR_LAYOUT_MANAGER = 'UPDATE_SORT_FOR_LAYOUT_MANAGER';
export const UPDATE_ORDER_FOR_LAYOUT_MANAGER = 'UPDATE_ORDER_FOR_LAYOUT_MANAGER';

export const INVALIDATE_LAYOUT_MANAGER_MAPPINGS = 'INVALIDATE_LAYOUT_MANAGER_MAPPINGS';

export const ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER = 'ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER';
export const ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST = 'ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST';
export const ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED = 'ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED';
export const ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED = 'ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED';

export const LAYOUT_MANAGER_ARRANGE_CONTENT = 'LAYOUT_MANAGER_ARRANGE_CONTENT';
export const UPDATE_LAYOUT_CONTENT = 'UPDATE_LAYOUT_CONTENT';
export const ADD_CONTENTS_TO_LAYOUT = 'ADD_CONTENTS_TO_LAYOUT';
export const RESET_LAYOUT_CONTENT = 'RESET_LAYOUT_CONTENT';

export const UPDATE_ALIAS_IN_LAYOUT_CONTENT = 'UPDATE_ALIAS_IN_LAYOUT_CONTENT';

export const REMOVE_LAYOUT_CONTENTS = 'REMOVE_LAYOUT_CONTENTS';

export const EDITOR_CONTENT_GRID_RENDER_ITEMS = 'EDITOR_CONTENT_GRID_RENDER_ITEMS';
export const EDITOR_CONTENT_GRID_ADD_FIELD = 'EDITOR_CONTENT_GRID_ADD_FIELD';
export const EDITOR_CONTENT_GRID_REMOVE_WIDGET = 'EDITOR_CONTENT_GRID_REMOVE_WIDGET';
export const EDITOR_CONTENT_GRID_UPDATE_CONTENT = 'EDITOR_CONTENT_GRID_UPDATE_CONTENT';
export const EDITOR_CONTENT_GRID_TOGGLE_FIELD_VISIBILITY = 'EDITOR_CONTENT_GRID_TOGGLE_FIELD_VISIBILITY';

export const AUTO_GROW_LAYOUT_REQUEST = 'AUTO_GROW_LAYOUT_REQUEST';

export const CREATE_HOTSPOT_WIDGET = 'CREATE_HOTSPOT_WIDGET';
export const TOGGLE_HOTSPOT_VIEW = 'TOGGLE_HOTSPOT_VIEW';

export const UPDATE_FILTERS_IN_CONTENT_GRID = 'UPDATE_FILTERS_IN_CONTENT_GRID';
export const UPDATE_QUERY_IN_CONTENT_GRID = 'UPDATE_QUERY_IN_CONTENT_GRID';
export const RESET_FILTERS_IN_CONTENT_GRID = 'RESET_FILTERS_IN_CONTENT_GRID';

/**
 * Content cards
 */
export const FETCH_CONTENT_CARDS_REQUEST = 'FETCH_CONTENT_CARDS_REQUEST';
export const FETCHING_CONTENT_CARDS_SUCCEEDED = 'FETCHING_CONTENT_CARDS_SUCCEEDED';
export const FETCHING_CONTENT_CARDS_FAILED = 'FETCHING_CONTENT_CARD_FALIED';
export const INVALIDATE_CONTENT_CARDS = 'INVALIDATE_CONTENT_CARDS';

export const FETCH_CONTENT_CARD_REQUEST = 'FETCH_CONTENT_CARD_REQUEST';
export const FETCHING_CONTENT_CARD_SUCCEEDED = 'FETCHING_CONTENT_CARD_SUCCEEDED';
export const FETCHING_CONTENT_CARD_FAILED = 'FETCHING_CONTENT_CARD_FAILED';
export const INVALIDATE_CONTENT_CARD = 'INVALIDATE_CONTENT_CARD';

export const EDITOR_CHANGE_CONTENT_GRID_CARD = 'EDITOR_CHANGE_CONTENT_GRID_CARD';

export const FETCH_PREVIEW_FOR_ASSET_REQUEST = 'FETCH_PREVIEW_FOR_ASSET_REQUEST';
export const FETCHING_PREVIEW_FOR_ASSET_SUCCEEDED = 'FETCHING_PREVIEW_FOR_ASSET_SUCCEEDED';
export const FETCHING_PREVIEW_FOR_ASSET_FAILED = 'FETCHING_PREVIEW_FOR_ASSET_FAILED';

export const FETCH_PREVIEW_TEXT_FOR_ASSET_REQUEST = 'FETCH_PREVIEW_TEXT_FOR_ASSET_REQUEST';
export const FETCHING_PREVIEW_TEXT_FOR_ASSET_SUCCEEDED = 'FETCHING_PREVIEW_TEXT_FOR_ASSET_SUCCEEDED';
export const FETCHING_PREVIEW_TEXT_FOR_ASSET_FAILED = 'FETCHING_PREVIEW_TEXT_FOR_ASSET_FAILED';

/**
* Landing Storyboard Reports
*/
export const FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE = 'FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE';
export const FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE_SUCCEEDED = 'FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE_SUCCEEDED';
export const FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE_FAILED = 'FETCHING_STORYBOARD_REPORT_SUMMARY_FAILED';

export const FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE = 'FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE';
export const FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED = 'FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED';
export const FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE_FAILED = 'FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE_FAILED';

export const FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE = 'FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE';
export const FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_SUCCEEDED = 'FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_SUCCEEDED';
export const FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_FAILED = 'FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_FAILED';

export const FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE = 'FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE';
export const FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED = 'FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED';
export const FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_FAILED = 'FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_FAILED';

export const FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE = 'FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE';
export const FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED = 'FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED';
export const FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE_FAILED = 'FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE_FAILED';

export const FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE = 'FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE';
export const FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE_SUCCEEDED = 'FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE_SUCCEEDED';
export const FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE_FAILED = 'FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE_FAILED';

export const FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS = "FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS";
export const FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_SUCCEEDED = "FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_SUCCEEDED";
export const FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_FAILED = "FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_FAILED";

//Download reports
export const FETCH_REPORTS_DATA_FOR_DOWNLOAD = "FETCH_REPORTS_DATA_FOR_DOWNLOAD";
export const FETCH_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED = "FETCH_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED";
export const FETCH_REPORTS_DATA_FOR_DOWNLOAD_FAILED = "FETCH_REPORTS_DATA_FOR_DOWNLOAD_FAILED";

//Analytics Chart For Landing Page 
export const FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE = "FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE";
export const FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_SUCCEEDED = "FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_SUCCEEDED";
export const FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_FAILED = "FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_FAILED";

//Analytics Chart For Interactive Page
export const FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE = "FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE";
export const FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_SUCCEEDED = "FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_SUCCEEDED";
export const FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_FAILED = "FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_FAILED";

export const FETCHING_STORYBOARD_METRICS_REPORTS = "FETCHING_STORYBOARD_METRICS_REPORTS";
export const FETCHING_STORYBOARD_METRICS_REPORTS_SUCCEEDED = "FETCHING_STORYBOARD_METRICS_REPORTS_SUCCEEDED";
export const FETCHING_STORYBOARD_METRICS_REPORTS_FAILED = "FETCHING_STORYBOARD_METRICS_REPORTS_FAILED";

//Analytics Chart (Trends Column) For Asset Analytics
export const FETCH_ANALYTICS_CHART_FOR_ASSET = "FETCH_ANALYTICS_CHART_FOR_ASSET";
export const FETCHING_ANALYTICS_CHART_FOR_ASSET_SUCCEEDED = "FETCHING_ANALYTICS_CHART_FOR_ASSET_SUCCEEDED";
export const FETCHING_ANALYTICS_CHART_FOR_ASSET_FAILED = "FETCHING_ANALYTICS_CHART_FOR_ASSET_FAILED";

//Fetch Preview For Document
export const FETCH_DOCUMENT_PREVIEW = "FETCH_DOCUMENT_PREVIEW";
export const FETCHING_DOCUMENT_PREVIEW_SUCCEEDED = "FETCHING_DOCUMENT_PREVIEW_SUCCEEDED";
export const FETCHING_DOCUMENT_PREVIEW_FAILED = "FETCHING_DOCUMENT_PREVIEW_FAILED";

//Invalidate Download Data
export const INVALIDATE_DOWNLOAD_DATA = "INVALIDATE_DOWNLOAD_DATA";

//Invalidate Asset Download Data
export const INVALIDATE_ASSET_DOWNLOAD_DATA = "INVALIDATE_ASSET_DOWNLOAD_DATA";

/**
* Live Elements 
*/
export const CREATE_LIVE_ELEMENT_REQUEST = 'CREATE_LIVE_ELEMENT_REQUEST';
export const CREATING_LIVE_ELEMENT_SUCCEEDED = 'CREATING_LIVE_ELEMENT_SUCCEEDED';
export const CREATING_LIVE_ELEMENT_FAILED = 'CREATING_LIVE_ELEMENT_FAILED';

export const BREAK_LIVE_ELEMENT_REQUEST = 'BREAK_LIVE_ELEMENT_REQUEST';

export const INVALIDATE_LIVE_ELEMENT = 'INVALIDATE_LIVE_ELEMENT';

export const FETCHING_LIVE_ELEMENTS_REQUEST = 'FETCHING_LIVE_ELEMENTS_REQUEST';
export const FETCHING_LIVE_ELEMENTS_SUCCEEDED = 'FETCHING_LIVE_ELEMENTS_SUCCEEDED';
export const FETCHING_LIVE_ELEMENTS_FAILED = 'FETCHING_LIVE_ELEMENTS_FAILED';

export const FETCHING_LIVE_ELEMENT_REQUEST = 'FETCHING_LIVE_ELEMENT_REQUEST';
export const FETCHING_LIVE_ELEMENT_SUCCEEDED = 'FETCHING_LIVE_ELEMENT_SUCCEEDED';
export const FETCHING_LIVE_ELEMENT_FAILED = 'FETCHING_LIVE_ELEMENT_FAILED';

export const DELETE_LIVE_ELEMENT_REQUEST = 'DELETE_LIVE_ELEMENT_REQUEST';
export const DELETING_LIVE_ELEMENT_SUCCEEDED = 'DELETING_LIVE_ELEMENT_SUCCEEDED';
export const DELETING_LIVE_ELEMENT_FAILED = 'DELETING_LIVE_ELEMENT_FAILED';

export const UPDATE_LIVE_ELEMENT_REQUEST = 'UPDATE_LIVE_ELEMENT_REQUEST';
export const UPDATING_LIVE_ELEMENT_SUCCEEDED = 'UPDATING_LIVE_ELEMENT_SUCCEEDED';
export const UPDATING_LIVE_ELEMENT_FAILED = 'UPDATING_LIVE_ELEMENT_FAILED';

export const RENAME_LIVE_ELEMENT_REQUEST = 'RENAME_LIVE_ELEMENT_REQUEST';

export const PUBLISH_LIVE_ELEMENT_REQUEST = "PUBLISH_LIVE_ELEMENT_REQUEST";
export const PUBLISHING_LIVE_ELEMENT_SUCCEEDED = "PUBLISHING_LIVE_ELEMENT_SUCCEEDED";
export const PUBLISHING_LIVE_ELEMENT_FAILED = "PUBLISHING_LIVE_ELEMENT_FAILED";

export const CLONE_LIVE_ELEMENT_REQUEST = "CLONE_LIVE_ELEMENT_REQUEST";
export const CLONING_LIVE_ELEMENT_SUCCEEDED = "CLONING_LIVE_ELEMENT_SUCCEEDED";
export const CLONING_LIVE_ELEMENT_FAILED = "CLONING_LIVE_ELEMENT_FAILED";

export const RELOAD_LIVE_ELEMENT_ON_CHANGE = "RELOAD_LIVE_ELEMENT_ON_CHANGE";

/**
* Gating
*/
export const FETCH_GATING_REQUEST = 'FETCH_GATING_REQUEST';
export const FETCHING_GATING_SUCCEEDED = 'FETCHING_GATING_SUCCEEDED';
export const FETCHING_GATING_FAILED = 'FETCHING_GATING_FAILED';

export const RESET_GATING = 'RESET_GATING';

export const FETCH_GATINGS_REQUEST = 'FETCH_GATINGS_REQUEST';
export const FETCHING_GATINGS_SUCCEEDED = 'FETCHING_GATINGS_SUCCEEDED';
export const FETCHING_GATINGS_FAILED = 'FETCHING_GATINGS_FAILED';

export const FETCH_PUBLISHED_GATINGS_REQUEST = 'FETCH_PUBLISHED_GATINGS_REQUEST';
export const FETCH_PUBLISHED_GATINGS_SUCCEEDED = 'FETCH_PUBLISHED_GATINGS_SUCCEEDED';
export const FETCH_PUBLISHED_GATINGS_FAILED = 'FETCH_PUBLISHED_GATINGS_FAILED';

export const CREATE_GATING_REQUEST = 'CREATE_GATING_REQUEST';
export const CREATING_GATING_SUCCEEDED = 'CREATING_GATING_SUCCEEDED';
export const CREATING_GATING_FAILED = 'CREATING_GATING_FAILED';

export const UPDATE_GATING_REQUEST = 'UPDATE_GATING_REQUEST';
export const UPDATING_GATING_SUCCEEDED = 'UPDATING_GATING_SUCCEEDED';
export const UPDATING_GATING_FAILED = 'UPDATING_GATING_FAILED';

export const DELETE_GATING_REQUEST = 'DELETE_GATING_REQUEST';
export const DELETING_GATING_SUCCEEDED = 'DELETING_GATING_SUCCEEDED';
export const DELETING_GATING_FAILED = 'DELETING_GATING_FAILED';

export const PUBLISH_GATING_REQUEST = 'PUBLISH_GATING_REQUEST';
export const PUBLISHING_GATING_SUCCEEDED = 'PUBLISHING_GATING_SUCCEEDED';
export const PUBLISHING_GATING_FAILED = 'PUBLISHING_GATING_FAILED';

export const RESTORE_GATING_REQUEST = 'RESTORE_GATING_REQUEST';
export const RESTORING_GATING_SUCCEEDED = 'RESTORING_GATING_SUCCEEDED';
export const RESTORING_GATING_FAILED = 'RESTORING_GATING_FAILED';

export const CLONE_GATING_REQUEST = 'CLONE_GATING_REQUEST';
export const CLONING_GATING_SUCCEEDED = 'CLONING_GATING_SUCCEEDED';
export const CLONING_GATING_FAILED = 'CLONING_GATING_FAILED';

export const CREATE_GATING_CONFIG_REQUEST = 'CREATE_GATING_CONFIG_REQUEST';
export const UPDATE_GATING_CONFIG_REQUEST = 'UPDATE_GATING_CONFIG_REQUEST';
export const DELETE_GATING_CONFIG_REQUEST = 'DELETE_GATING_CONFIG_REQUEST';
export const RESET_GATING_CONFIG_REQUEST = 'RESET_GATING_CONFIG_REQUEST';

export const FETCH_GATING_CONFIGS_REQUEST = 'FETCH_GATING_CONFIGS_REQUEST';
export const FETCH_GATING_CONFIGS_SUCCEED = 'FETCH_GATING_CONFIGS_SUCCEED';
export const FETCH_GATING_CONFIGS_FAILED = 'FETCH_GATING_CONFIGS_FAILED';
export const UPDATE_GATING_CONFIGS_PROPERTIES = 'UPDATE_GATING_CONFIGS_PROPERTIES';

export const UPDATE_GATING_SETTINGS = 'UPDATE_GATING_SETTINGS';
export const UPDATE_GATING_PROGRESSIVE_PROPERTIES = 'UPDATE_GATING_PROGRESSIVE_PROPERTIES';
export const INVALIDATE_GATING_STATE = 'INVALIDATE_GATING_STATE';

/** ------------- PROGRESSIVE GATING ------------- */

export const UPDATE_PROGRESSIVE_GATING_PROPERTY = 'UPDATE_PROGRESSIVE_GATING_PROPERTY';

/**
 * Forms
 */
export const FETCHING_FORM_REQUEST = "FETCHING_FORM_REQUEST";
export const FETCHING_FORM_SUCCEEDED = "FETCHING_FORM_SUCCEEDED";
export const FETCHING_FORM_FAILED = "FETCHING_FORM_FAILED";

export const FETCHING_CREATED_FORMS = 'FETCHING_CREATED_FORMS';
export const FETCHING_CREATED_FORMS_SUCCEEDED = 'FETCHING_CREATED_FORMS_SUCCEEDED';
export const FETCHING_CREATED_FORMS_FAILED = 'FETCHING_CREATED_FORMS_FAILED';

export const FORM_MANAGE_VIEW = 'FORM_MANAGE_VIEW';
export const INVALIDATE_FORMS = 'INVALIDATE_FORMS';

/**
 * Hubspot Forms
 */
export const CREATING_HUBSPOT_FORM_REQUEST = "CREATING_HUBSPOT_FORM_REQUEST";
export const CREATING_HUBSPOT_FORM_SUCCEDDED = "CREATING_HUBSPOT_FORM_SUCCEDDED";
export const CREATING_HUBSPOT_FORM_FAILED = "CREATING_HUBSPOT_FORM_FAILED";

export const UPDATING_HUBSPOT_FORM_REQUEST = "UPDATING_HUBSPOT_FORM_REQUEST";
export const UPDATING_HUBSPOT_FORM_SUCCEEDED = "UPDATING_HUBSPOT_FORM_SUCCEEDED";
export const UPDATING_HUBSPOT_FORM_FAILED = "UPDATING_HUBSPOT_FORM_FAILED";

export const DELETING_HUBSPOT_FORM_REQUEST = 'DELETING_HUBSPOT_FORM_REQUEST';
export const DELETING_HUBSPOT_FORM_SUCCEEDED = 'DELETING_HUBSPOT_FORM_SUCCEEDED';
export const DELETING_HUBSPOT_FORM_FAILED = 'DELETING_HUBSPOT_FORM_FAILED';

export const SELECT_HUBSPOT_FORM = 'SELECT_HUBSPOT_FORM';

/**
 * Marketo Forms
 */
export const CREATING_MARKETO_FORM_REQUEST = "CREATING_MARKETO_FORM_REQUEST";
export const CREATING_MARKETO_FORM_SUCCEDDED = "CREATING_MARKETO_FORM_SUCCEDDED";
export const CREATING_MARKETO_FORM_FAILED = "CREATING_MARKETO_FORM_FAILED";

export const UPDATING_MARKETO_FORM_REQUEST = "UPDATING_MARKETO_FORM_REQUEST";
export const UPDATING_MARKETO_FORM_SUCCEEDED = "UPDATING_MARKETO_FORM_SUCCEEDED";
export const UPDATING_MARKETO_FORM_FAILED = "UPDATING_MARKETO_FORM_FAILED";

export const DELETING_MARKETO_FORM_REQUEST = 'DELETING_MARKETO_FORM_REQUEST';
export const DELETING_MARKETO_FORM_SUCCEEDED = 'DELETING_MARKETO_FORM_SUCCEEDED';
export const DELETING_MARKETO_FORM_FAILED = 'DELETING_MARKETO_FORM_FAILED';

export const SELECT_MARKETO_FORM = 'SELECT_MARKETO_FORM';

/**
 * Pardot Forms
 */
export const CREATING_PARDOT_FORM_REQUEST = "CREATING_PARDOT_FORM_REQUEST";
export const CREATING_PARDOT_FORM_SUCCEDDED = "CREATING_PARDOT_FORM_SUCCEDDED";
export const CREATING_PARDOT_FORM_FAILED = "CREATING_PARDOT_FORM_FAILED";

export const UPDATING_PARDOT_FORM_REQUEST = "UPDATING_PARDOT_FORM_REQUEST";
export const UPDATING_PARDOT_FORM_SUCCEEDED = "UPDATING_PARDOT_FORM_SUCCEEDED";
export const UPDATING_PARDOT_FORM_FAILED = "UPDATING_PARDOT_FORM_FAILED";

export const DELETING_PARDOT_FORM_REQUEST = 'DELETING_PARDOT_FORM_REQUEST';
export const DELETING_PARDOT_FORM_SUCCEEDED = 'DELETING_PARDOT_FORM_SUCCEEDED';
export const DELETING_PARDOT_FORM_FAILED = 'DELETING_PARDOT_FORM_FAILED';

export const SELECT_PARDOT_FORM = 'SELECT_PARDOT_FORM';

/**
 * External Forms
 */
export const CREATING_EXTERNAL_FORM_REQUEST = 'CREATING_EXTERNAL_FORM_REQUEST';
export const CREATING_EXTERNAL_FORM_SUCCEEDED = 'CREATING_EXTERNAL_FORM_SUCCEEDED';
export const CREATING_EXTERNAL_FORM_FAILED = 'CREATING_EXTERNAL_FORM_FAILED';

export const UPDATING_EXTERNAL_FORM_REQUEST = 'UPDATING_EXTERNAL_FORM_REQUEST';
export const UPDATING_EXTERNAL_FORM_SUCCEEDED = 'UPDATING_EXTERNAL_FORM_SUCCEEDED';
export const UPDATING_EXTERNAL_FORM_FAILED = 'UPDATING_EXTERNAL_FORM_FAILED';

export const DELETING_EXTERNAL_FORM_REQUEST = 'DELETING_EXTERNAL_FORM_REQUEST';
export const DELETING_EXTERNAL_FORM_SUCCEEDED = 'DELETING_EXTERNAL_FORM_SUCCEEDED';
export const DELETING_EXTERNAL_FORM_FAILED = 'DELETING_EXTERNAL_FORM_FAILED';

/**
 * Custom Form Fields
 */

export const FETCHING_CUSTOM_FORM_FIELDS = "FETCHING_CUSTOM_FORM_FIELDS";
export const FETCHING_CUSTOM_FORM_FIELDS_SUCCEEDED = "FETCHING_CUSTOM_FORM_FIELDS_SUCCEEDED";
export const FETCHING_CUSTOM_FORM_FIELDS_FAILED = "FETCHING_CUSTOM_FORM_FIELDS_FAILED";

export const DELETING_CUSTOM_FORM_FIELD = "DELETING_CUSTOM_FORM_FIELD";
export const DELETING_CUSTOM_FORM_FIELD_SUCCEEDED = "DELETING_CUSTOM_FORM_FIELD_SUCCEEDED";
export const DELETING_CUSTOM_FORM_FIELD_FAILED = "DELETING_CUSTOM_FORM_FIELD_FAILED";

export const FETCHING_CUSTOM_FORM_FIELD = "FETCHING_CUSTOM_FORM_FIELD";
export const FETCHING_CUSTOM_FORM_FIELD_SUCCEEDED = "FETCHING_CUSTOM_FORM_FIELD_SUCCEEDED";
export const FETCHING_CUSTOM_FORM_FIELD_FAILED = "FETCHING_CUSTOM_FORM_FIELD_FAILED";

export const CREATE_CUSTOM_FORM_FIELD = "CREATE_CUSTOM_FORM_FIELD";
export const CREATING_CUSTOM_FORM_FIELD_SUCCEEDED = "CREATING_CUSTOM_FORM_FIELD_SUCCEEDED";
export const CREATING_CUSTOM_FORM_FIELD_FAILED = "CREATING_CUSTOM_FORM_FIELD_FAILED";

export const UPDATE_CUSTOM_FORM_FIELD = "UPDATE_CUSTOM_FORM_FIELD";
export const UPDATING_CUSTOM_FORM_FIELD_SUCCEEDED = "UPDATING_CUSTOM_FORM_FIELD_SUCCEEDED";
export const UPDATING_CUSTOM_FORM_FIELD_FAILED = "UPDATING_CUSTOM_FORM_FIELD_FAILED";

export const INVALIDATE_CUSTOM_FORM_FIELDS = "INVALIDATE_CUSTOM_FORM_FIELDS";

/**
 * Gating Configurations
 */

export const CREATE_GATING_CONFIGURATION_REQUEST = "CREATE_GATING_CONFIGURATION_REQUEST";

export const CREATE_ASSET_MAPPING_GATING_CONFIGURATION = "CREATE_ASSET_MAPPING_GATING_CONFIGURATION";

export const UPDATE_GATING_CONFIGURATION_REQUEST = "UPDATE_GATING_CONFIGURATION_REQUEST";
export const DELETE_GATING_CONFIGURATION_REQUEST = "DELETE_GATING_CONFIGURATION_REQUEST";

export const INVALIDATE_GATING_CONFIGURATIONS = "INVALIDATE_GATING_CONFIGURATIONS";

export const CREATE_GATING_CONFIGURATION_FOR_MAPPING_REQUEST = "CREATE_GATING_CONFIGURATION_FOR_MAPPING_REQUEST";
export const CREATING_GATING_CONFIGURATION_FOR_MAPPING_SUCCEEDED = "CREATING_GATING_CONFIGURATION_FOR_MAPPING_SUCCEEDED";
export const CREATING_GATING_CONFIGURATION_FOR_MAPPING_FAILED = "CREATING_GATING_CONFIGURATION_FOR_MAPPING_FAILED";


export const FETCH_GATING_CONFIGURATIONS_FOR_MAPPING_REQUEST = "FETCH_GATING_CONFIGURATIONS_FOR_MAPPING_REQUEST";
export const FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_SUCCEEDED = "FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_SUCCEEDED";
export const FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_FAILED = "FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_FAILED";
/**
 * Asset aliases
 */
export const FETCH_ALIASES_FOR_ASSET_REQUEST = "FETCH_ALIASES_FOR_ASSET_REQUEST";
export const FETCHING_ALIASES_FOR_ASSET_SUCCEDDED = "FETCHING_ALIASES_FOR_ASSET_SUCCEDDED";
export const FETCHING_ALIASES_FOR_ASSET_FAILED = "FETCHING_ALIASES_FOR_ASSET_FAILED";

export const CREATE_ALIASES_FOR_ASSET = "CREATE_ALIASES_FOR_ASSET";
export const CREATING_ALIASES_FOR_ASSET_SUCCEEDED = "CREATING_ALIASES_FOR_ASSET_SUCCEEDED";
export const CREATING_ALIASES_FOR_ASSET_FAILED = "CREATING_ALIASES_FOR_ASSET_FAILED";
export const INVALIDATE_CREATE_ALIASES_FOR_ASSET = "INVALIDATE_CREATE_ALIASES_FOR_ASSET";

export const UPDATE_ALIASES_FOR_ASSET = "UPDATE_ALIASES_FOR_ASSET";
export const UPDATING_ALIASES_FOR_ASSET_SUCCEEDED = "UPDATING_ALIASES_FOR_ASSET_SUCCEEDED";
export const UPDATING_ALIASES_FOR_ASSET_FAILED = "UPDATING_ALIASES_FOR_ASSET_FAILED";

export const DELETE_ALIASES_FOR_ASSET = "DELETE_ALIASES_FOR_ASSET";
export const DELETING_ALIASES_FOR_ASSET_SUCCEEDED = "DELETING_ALIASES_FOR_ASSET_SUCCEEDED";
export const DELETING_ALIASES_FOR_ASSET_FAILED = "DELETING_ALIASES_FOR_ASSET_FAILED";

export const INVALIDATE_ALIASES_FOR_ASSET = "INVALIDATE_ALIASES_FOR_ASSET";


/**
 * Custom Fields
 */

export const FETCHING_CUSTOM_FIELDS = "FETCHING_CUSTOM_FIELDS";
export const FETCHING_CUSTOM_FIELDS_SUCCEEDED = "FETCHING_CUSTOM_FIELDS_SUCCEEDED";
export const FETCHING_CUSTOM_FIELDS_FAILED = "FETCHING_CUSTOM_FIELDS_FAILED";

export const DELETING_CUSTOM_FIELD = "DELETING_CUSTOM_FIELD";
export const DELETING_CUSTOM_FIELD_SUCCEEDED = "DELETING_CUSTOM_FIELD_SUCCEEDED";
export const DELETING_CUSTOM_FIELD_FAILED = "DELETING_CUSTOM_FIELD_FAILED";

export const FETCHING_CUSTOM_FIELD = "FETCHING_CUSTOM_FIELD";
export const FETCHING_CUSTOM_FIELD_SUCCEEDED = "FETCHING_CUSTOM_FIELD_SUCCEEDED";
export const FETCHING_CUSTOM_FIELD_FAILED = "FETCHING_CUSTOM_FIELD_FAILED";

export const FETCHING_PAPERFLITE_CUSTOM_FIELDS = "FETCHING_PAPERFLITE_CUSTOM_FIELDS";
export const FETCHING_PAPERFLITE_CUSTOM_FIELDS_SUCCEEDED = "FETCHING_PAPERFLITE_CUSTOM_FIELDS_SUCCEEDED";
export const FETCHING_PAPERFLITE_CUSTOM_FIELDS_FAILED = "FETCHING_PAPERFLITE_CUSTOM_FIELDS_FAILED";

export const FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC = "FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC";
export const FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC_SUCCEEDED = "FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC_SUCCEEDED";
export const FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC_FAILED = "FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC_FAILED";

export const CREATE_CUSTOM_FIELD = "CREATE_CUSTOM_FIELD";
export const CREATING_CUSTOM_FIELD_SUCCEEDED = "CREATING_CUSTOM_FIELD_SUCCEEDED";
export const CREATING_CUSTOM_FIELD_FAILED = "CREATING_CUSTOM_FIELD_FAILED";

export const CREATE_CUSTOM_FIELD_FROM_PAPERFLITE = "CREATE_CUSTOM_FIELD_FROM_PAPERFLITE";
export const CREATING_CUSTOM_FIELD_FROM_PAPERFLITE_SUCCEEDED = "CREATING_CUSTOM_FIELD_FROM_PAPERFLITE_SUCCEEDED";
export const CREATING_CUSTOM_FIELD_FROM_PAPERFLITE_FAILED = "CREATING_CUSTOM_FIELD_FROM_PAPERFLITE_FAILED";

export const UPDATE_CUSTOM_FIELD = "UPDATE_CUSTOM_FIELD";
export const UPDATING_CUSTOM_FIELD_SUCCEEDED = "UPDATING_CUSTOM_FIELD_SUCCEEDED";
export const UPDATING_CUSTOM_FIELD_FAILED = "UPDATING_CUSTOM_FIELD_FAILED";

export const INVALIDATE_CUSTOM_FIELDS = "INVALIDATE_CUSTOM_FIELDS";


/**
 * Pexel integrations
 **/
export const FETCHING_EXTERNAL_LIBRARY = "FETCHING_EXTERNAL_LIBRARY";
export const FETCHING_EXTERNAL_LIBRARY_SUCCEDED = "FETCHING_EXTERNAL_LIBRARY_SUCCEDED";
export const FETCHING_EXTERNAL_LIBRARY_FAILED = "FETCHING_EXTERNAL_LIBRARY_FAILED";

export const INVALIDATE_EXTERNAL_LIBRARY = "INVALIDATE_EXTERNAL_LIBRARY";
export const SELECT_EXTERNAL_MEDIA = "SELECT_EXTERNAL_MEDIA";
export const INVALIDATE_SELECTION = "INVALIDATE_SELECTION";

/*
  seek indexing for assets
*/
export const ASSET_SEEK_INDEXING_REQUEST = "ASSET_SEEK_INDEXING_REQUEST";
export const ASSET_SEEK_INDEXING_SUCCEEDED = "ASSET_SEEK_INDEXING_SUCCEEDED";
export const ASSET_SEEK_INDEXING_FAILED = "ASSET_SEEK_INDEXING_FAILED";


/**
 * Versioning Actions
 **/
export const CREATE_NEW_VERSION_REQUEST = 'CREATE_NEW_VERSION_REQUEST';
export const CREATE_NEW_VERSION_SUCCEEDED = 'CREATE_NEW_VERSION_SUCCEEDED';
export const CREATE_NEW_VERSION_FAILED = 'CREATE_NEW_VERSION_FAILED';

export const INVALIDATE_CREATE_STATE = 'INVALIDATE_CREATE_STATE';

export const FETCH_VERSIONS_REQUEST = 'FETCH_VERSIONS_REQUEST';
export const FETCHING_VERSIONS_SUCCEEDED = 'FETCHING_VERSIONS_SUCCEEDED';
export const FETCHING_VERSIONS_FAILED = 'FETCHING_VERSIONS_FAILED';

export const FETCH_VERSION_REQUEST = 'FETCH_VERSION_REQUEST';
export const FETCHING_VERSION_SUCCEEDED = 'FETCHING_VERSION_SUCCEEDED';
export const FETCHING_VERSION_FAILED = 'FETCHING_VERSION_FAILED';

export const DELETE_VERSION_REQUEST = 'DELETE_VERSION_REQUEST';
export const DELETING_VERSION_SUCCEEDED = 'DELETING_VERSION_SUCCEEDED';
export const DELETING_VERSION_FAILED = 'DELETING_VERSION_FAILED';

export const RESTORE_VERSION_REQUEST = 'RESTORE_VERSION_REQUEST';
export const RESTORING_VERSION_SUCCEEDED = 'RESTORING_VERSION_SUCCEEDED';
export const RESTORING_VERSION_FAILED = 'RESTORING_VERSION_FAILED';

export const INVALIDATE_RESTORE_STATE = 'INVALIDATE_RESTORE_STATE';

export const RENAME_VERSION_REQUEST = 'RENAME_VERSION_REQUEST';
export const RENAMING_VERSION_SUCCEEDED = 'RENAMING_VERSION_SUCCEEDED';
export const RENAMING_VERSION_FAILED = 'RENAMING_VERSION_FAILED';

/**
 * Lock Page
*/
export const ACQUIRE_LOCK_FOR_ENTITY_REQUEST = 'ACQUIRE_LOCK_FOR_ENTITY_REQUEST';
export const ACQUIRING_LOCK_FOR_ENTITY_SUCCEDDED = 'ACQUIRING_LOCK_FOR_ENTITY_SUCCEDDED';
export const ACQUIRING_LOCK_FOR_ENTITY_FAILED = 'ACQUIRING_LOCK_FOR_ENTITY_FAILED';

export const RELEASE_LOCK_FOR_ENTITY_REQUEST = 'RELEASE_LOCK_FOR_ENTITY_REQUEST';
export const RELEASING_LOCK_FOR_ENTITY_SUCCEDDED = 'RELEASING_LOCK_FOR_ENTITY_SUCCEDDED';
export const RELEASING_LOCK_FOR_ENTITY_FAILED = 'RELEASING_LOCK_FOR_ENTITY_FAILED';

export const BREAK_LOCK_FOR_ENTITY_REQUEST = 'BREAK_LOCK_FOR_ENTITY_REQUEST';
export const BREAKING_LOCK_FOR_ENTITY_SUCCEDDED = 'BREAKING_LOCK_FOR_ENTITY_SUCCEDDED';
export const BREAKING_LOCK_FOR_ENTITY_FAILED = 'BREAKING_LOCK_FOR_ENTITY_FAILED';

export const INVALIDATE_LOCK_STATE = 'INVALIDATE_LOCK_STATE';

export const WS_ENTITY_LOCK_BROKEN = 'WS_ENTITY_LOCK_BROKEN';
export const WS_FIGMA_UPLOAD_PROGRESS = 'WS_FIGMA_UPLOAD_PROGRESS';

/**
 * Asset Journey 
*/
export const FETCH_JOURNEYS_REQUEST = "FETCH_JOURNEYS_REQUEST";
export const FETCHING_JOURNEYS_SUCCEDDED = "FETCHING_JOURNEYS_SUCCEDDED";
export const FETCHING_JOURNEYS_FAILED = "FETCHING_JOURNEYS_FAILED";

export const FETCH_JOURNEY_REQUEST = "FETCH_JOURNEY_REQUEST";
export const FETCHING_JOURNEY_SUCCEDDED = "FETCHING_JOURNEY_SUCCEDDED";
export const FETCHING_JOURNEY_FAILED = "FETCHING_JOURNEY_FAILED";

export const CREATE_JOURNEY_REQUEST = "CREATE_JOURNEY_REQUEST";
export const CREATE_JOURNEY_SUCCEDDED = "CREATE_JOURNEY_SUCCEDDED";
export const CREATE_JOURNEY_FAILED = "CREATE_JOURNEY_FAILED";

export const UPDATE_JOURNEY_REQUEST = "UPDATE_JOURNEY_REQUEST";
export const UPDATING_JOURNEY_SUCCEDDED = "UPDATING_JOURNEY_SUCCEDDED";
export const UPDATING_JOURNEY_FAILED = "UPDATING_JOURNEY_FAILED";

export const DELETE_JOURNEY_REQUEST = "DELETE_JOURNEY_REQUEST";
export const DELETING_JOURNEY_SUCCEDDED = "DELETING_JOURNEY_SUCCEDDED";
export const DELETING_JOURNEY_FAILED = "DELETING_JOURNEY_FAILED";

export const CREATE_JOURNEY_STEP = "CREATE_JOURNEY_STEP";
export const CREATE_JOURNEY_STEP_SUCCEDDED = "CREATE_JOURNEY_STEP_SUCCEDDED";
export const CREATE_JOURNEY_STEP_FAILED = "CREATE_JOURNEY_STEP_FAILED";

export const UPDATE_JOURNEY_DATA_REQUEST = "UPDATE_JOURNEY_DATA_REQUEST";

export const UPDATE_JOURNEY_STEP = "UPDATE_JOURNEY_STEP";
export const UPDATING_JOURNEY_STEP_SUCCEDDED = "UPDATING_JOURNEY_STEP_SUCCEDDED";
export const UPDATING_JOURNEY_STEP_FAILED = "UPDATING_JOURNEY_STEP_FAILED";

export const DELETE_JOURNEY_STEP = "DELETE_JOURNEY_STEP";
export const DELETING_JOURNEY_STEP_SUCCEDDED = "DELETING_JOURNEY_STEP_SUCCEDDED";
export const DELETING_JOURNEY_STEP_FAILED = "DELETING_JOURNEY_STEP_FAILED";

export const NUDGE_TRIGGERED_REQUEST = 'NUDGE_TRIGGERED_REQUEST';
export const NUDGE_TRIGGERED_SUCCEEDED = 'NUDGE_TRIGGERED_SUCCEEDED';
export const NUDGE_TRIGGERED_FAILED = 'NUDGE_TRIGGERED_FAILED';

export const TRIGGER_NUDGE = 'TRIGGER_NUDGE';

export const UPDATE_JOURNEY_DYNAMIC_CONTENT_MANAGER = 'UPDATE_JOURNEY_DYNAMIC_CONTENT_MANAGER';

export const FETCH_FILTER_MAPPINGS_FOR_JOURNEY_REQUEST = "FETCH_FILTER_MAPPINGS_FOR_JOURNEY_REQUEST"
export const FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_SUCCEEDED = "FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_SUCCEEDED";
export const FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_FAILED = "FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_FAILED";
export const INVALIDATE_JOURNEY_CONTENT_MANAGER_MAPPINGS = "INVALIDATE_JOURNEY_CONTENT_MANAGER_MAPPINGS";
/**
 * Mixpanel
*/

export const CREATE_MIXPANEL_EVENT_REQUEST = 'CREATE_MIXPANEL_REQUEST';
export const CREATING_MIXPANEL_EVENT_SUCCEEDED = 'CREATING_MIXPANEL_EVENT_SUCCEEDED';
export const CREATING_MIXPANEL_EVENT_FAILED = 'CREATING_MIXPANEL_EVENT_FAILED';

export const IDENTIFY_MIXPANEL_USER_REQUEST = 'IDENTIFY_MIXPANEL_USER_REQUEST';
export const IDENTIFY_MIXPANEL_USER_SUCCEEDED = 'IDENTIFY_MIXPANEL_USER_SUCCEEDED';
export const IDENTIFY_MIXPANEL_USER_FAILED = 'IDENTIFY_MIXPANEL_USER_FAILED';

/**
 * Workspace Reports
*/

export const FETCHING_WORKSPACE_REPORT_SUMMARY = 'FETCHING_WORKSPACE_REPORT_SUMMARY';
export const FETCHING_WORKSPACE_REPORT_SUMMARY_SUCCEDED = 'FETCHING_WORKSPACE_REPORT_SUMMARY_SUCCEDED';
export const FETCHING_WORKSPACE_REPORT_SUMMARY_FAILED = 'FETHING_WORKSPACE_REPORT_SUMMARY_FAILED';

export const FETCHING_WORKSPACE_SESSION_ANALYTICS = 'FETCHING_WORKSPACE_SESSION_ANALYTICS';
export const FETCHING_WORKSPACE_SESSION_ANALYTICS_SUCCEDED = 'FETCHING_WORKSPACE_SESSION_ANALYTICS_SUCCEDED';
export const FETCHING_WORKSPACE_SESSION_ANALYTICS_FAILED = 'FETCHING_WORKSPACE_SESSION_ANALYTICS_FAILED';

export const FETCHING_WORKSPACE_LEAD_REPORTS = 'FETCHING_WORKSPACE_LEAD_REPORTS';
export const FETCHING_WORKSPACE_LEAD_REPORTS_SUCCEDED = 'FETCHING_WORKSPACE_LEAD_REPORTS_SUCCEDED';
export const FETCHING_WORKSPACE_LEAD_REPORTS_FAILED = 'FETCHING_WORKSPACE_LEAD_REPORTS_FAILED';

export const CREATE_PERSONALIZATION_LEAD_REQUEST = 'CREATE_PERSONALIZATION_LEAD_REQUEST';
export const CREATING_PERSONALIZATION_LEAD_SUCCEEDED = 'CREATING_PERSONALIZATION_LEAD_SUCCEEDED';
export const CREATING_PERSONALIZATION_LEAD_FAILED = 'CREATING_PERSONALIZATION_LEAD_FAILED';

export const UPDATE_PERSONALIZATION_LEAD_REQUEST = 'UPDATE_PERSONALIZATION_LEAD_REQUEST';
export const UPDATING_PERSONALIZATION_LEAD_SUCCEEDED = 'UPDATING_PERSONALIZATION_LEAD_SUCCEEDED';
export const UPDATING_PERSONALIZATION_LEAD_FAILED = 'UPDATING_PERSONALIZATION_LEAD_FAILED';

export const DELETE_PERSONALIZATION_LEAD_REQUEST = 'DELETE_PERSONALIZATION_LEAD_REQUEST';
export const DELETING_PERSONALIZATION_LEAD_SUCCEEDED = 'DELETING_PERSONALIZATION_LEAD_SUCCEEDED';
export const DELETING_PERSONALIZATION_LEAD_FAILED = 'DELETING_PERSONALIZATION_LEAD_FAILED';

export const UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST = 'UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST ';
export const UPLOADING_LEADS_FOR_PERSONALIZATION_SUCCEEDED = 'UPLOADING_LEADS_FOR_PERSONALIZATION_SUCCEEDED';
export const UPLOADING_LEADS_FOR_PERSONALIZATION_FAILED = 'UPLOADING_LEADS_FOR_PERSONALIZATION_FAILED';

export const FETCHING_PERSONALIZATION_LEADS_REQUEST = 'FETCHING_PERSONALIZATION_LEADS_REQUEST';
export const FETCHING_PERSONALIZATION_LEADS_SUCCEDED = 'FETCHING_PERSONALIZATION_LEADS_SUCCEDED';
export const FETCHING_PERSONALIZATION_LEADS_FAILED = 'FETCHING_PERSONALIZATION_LEADS_FAILED';

export const FETCHING_PERSONALIZATION_LINKS_REQUEST = 'FETCHING_PERSONALIZATION_LINKS_REQUEST';
export const FETCHING_PERSONALIZATION_LINKS_SUCCEDED = 'FETCHING_PERSONALIZATION_LINKS_SUCCEDED';
export const FETCHING_PERSONALIZATION_LINKS_FAILED = 'FETCHING_PERSONALIZATION_LINKS_FAILED';

export const FETCHING_PERSONALIZATION_CONTACTS = 'FETCHING_PERSONALIZATION_CONTACTS';
export const FETCHING_PERSONALIZATION_CONTACTS_SUCCEEDED = 'FETCHING_PERSONALIZATION_CONTACTS_SUCCEEDED';
export const FETCHING_PERSONALIZATION_CONTACTS_FAILED = 'FETCHING_PERSONALIZATION_CONTACTS_FAILED';

export const FETCHING_WORKSPACE_ASSET_ANALYTICS = 'FETCHING_WORKSPACE_ASSET_ANALYTICS';
export const FETCHING_WORKSPACE_ASSET_ANALYTICS_SUCCEDED = 'FETCHING_WORKSPACE_ASSET_ANALYTICS_SUCCEDED';
export const FETCHING_WORKSPACE_ASSET_ANALYTICS_FAILED = 'FETCHING_WORKSPACE_ASSET_ANALYTICS_FAILED';

export const FETCHING_WORKSPACE_STORYBOARD_REPORTS = 'FETCHING_WORKSPACE_STORYBOARD_REPORTS';
export const FETCHING_WORKSPACE_STORYBOARD_REPORTS_SUCCEDED = 'FETCHING_WORKSPACE_STORYBOARD_REPORTS_SUCCEDED';
export const FETCHING_WORKSPACE_STORYBOARD_REPORTS_FAILED = 'FETCHING_WORKSPACE_STORYBOARD_REPORTS_FAILED';

export const UPDATE_PERSONALIZATION_REQUEST = 'UPDATE_PERSONALIZATION_REQUEST';
export const UPDATING_PERSONALIZATION_SUCCEEDED = 'UPDATING_PERSONALIZATION_SUCCEEDED';
export const UPDATING_PERSONALIZATION_FAILED = 'UPDATING_PERSONALIZATION_FAILED';

export const UPDATE_PERSONALIZATION_ALIAS_REQUEST = 'UPDATE_PERSONALIZATION_ALIAS_REQUEST';
export const UPDATING_PERSONALIZATION_ALIAS_SUCCEEDED = 'UPDATING_PERSONALIZATION_ALIAS_SUCCEEDED';
export const UPDATING_PERSONALIZATION_ALIAS_FAILED = 'UPDATING_PERSONALIZATION_ALIAS_FAILED';

export const DELETE_PERSONALIZATION_REQUEST = 'DELETE_PERSONALIZATION_REQUEST';
export const DELETING_PERSONALIZATION_SUCCEEDED = 'DELETING_PERSONALIZATION_SUCCEEDED';
export const DELETING_PERSONALIZATION_FAILED = 'DELETING_PERSONALIZATION_FAILED';

export const CREATE_PERSONALIZED_ALIAS_REQUEST = 'CREATE_PERSONALIZED_ALIAS_REQUEST';
export const CREATING_PERSONALIZED_ALIAS_SUCCEDED = 'CREATING_PERSONALIZED_ALIAS_SUCCEDED';
export const CREATING_PERSONALIZED_ALIAS_FAILED = 'CREATE_PERSONALIZED_ALIAS_FAILED';

export const FETCHING_PERSONALISATION_FORM_FIELD_REQUEST = 'FETCHING_PERSONALISATION_FORM_FIELD_REQUEST';
export const FETCHING_PERSONALISATION_FORM_FIELD_SUCCEEDED = 'FETCHING_PERSONALISATION_FORM_FIELD_SUCCEEDED';
export const FETCHING_PERSONALISATION_FORM_FIELD_FAILED = 'FETCHING_PERSONALISATION_FORM_FIELD_FAILED';

export const INVALIDATE_PERSONALIZATION_LEADS = 'INVALIDATE_PERSONALIZATION_LEADS';
export const INVALIDATE_PERSONALIZATION = 'INVALIDATE_PERSONALIZATION';

export const INVALID_WORKSPACE_REPORTS = 'INVALID_WORKSPACE_REPORTS';

/** Workpsace Download */

export const FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD = 'FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD';
export const FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_SUCCEEDED = 'FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_SUCCEEDED';
export const FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_FAILED = 'FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_FAILED';

export const FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD = 'FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD';
export const FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED = 'FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED';
export const FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_FAILED = 'FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_FAILED';

export const FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD = 'FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD';
export const FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED = 'FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED';
export const FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_FAILED = 'FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_FAILED';

export const FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD = 'FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD';
export const FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED = 'FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED';
export const FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_FAILED = 'FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_FAILED';

export const INVALIDATE_STORYBOARD_REPORTS_DOWNLOAD_DATA = "INVALIDATE_STORYBOARD_REPORTS_DOWNLOAD_DATA"
export const INVALIDATE_SESSION_ANALYTICS_DOWNLOAD_DATA = "INVALIDATE_SESSION_ANALYTICS_DOWNLOAD_DATA"
export const INVALIDATE_LEAD_ANALYTICS_DOWNLOAD_DATA = "INVALIDATE_LEAD_ANALYTICS_DOWNLOAD_DATA"
export const INVALIDATE_ASSET_ANALYTICS_DOWNLOAD_DATA = "INVALIDATE_ASSET_ANALYTICS_DOWNLOAD_DATA"

/**
 * Variables Actions
 */
export const FETCH_VARIABLES_REQUEST = 'FETCH_VARIABLES_REQUEST';
export const FETCH_VARIABLES_SUCCEEDED = 'FETCH_VARIABLES_SUCCEEDED';
export const FETCH_VARIABLES_FAILED = 'FETCH_VARIABLES_FAILED';

export const CREATE_VARIABLES_REQUEST = 'CREATE_VARIABLES_REQUEST';
export const CREATE_VARIABLES_SUCCEEDED = 'CREATE_VARIABLES_SUCCEEDED';
export const CREATE_VARIABLES_FAILED = 'CREATE_VARIABLES_FAILED';

export const UPDATE_VARIABLES_REQUEST = 'UPDATE_VARIABLES_REQUEST';
export const UPDATE_VARIABLES_SUCCEEDED = 'UPDATE_VARIABLES_SUCCEEDED';
export const UPDATE_VARIABLES_FAILED = 'UPDATE_VARIABLES_FAILED';

export const DELETE_VARIABLES_REQUEST = 'DELETE_VARIABLES_REQUEST';
export const DELETE_VARIABLES_SUCCEEDED = 'DELETE_VARIABLES_SUCCEEDED';
export const DELETE_VARIABLES_FAILED = 'DELETE_VARIABLES_FAILED';

export const CREATE_VARIABLE_MAPPINGS = "CREATE_VARIABLE_MAPPINGS";
export const UPDATE_VARIABLE_MAPPINGS = 'UPDATE_VARIABLE_MAPPINGS';
export const REMOVE_VARIABLE_MAPPINGS = 'REMOVE_VARIABLE_MAPPINGS';

export const INVALIDATE_VARIABLE_MAPPINGS = 'INVALIDATE_VARIABLE_MAPPINGS';
export const INVALIDATE_VARIABLES = 'INVALIDATE_VARIABLES';


/** PAGE HEALTH */
export const FETCH_PAGE_HEALTH = 'FETCH_PAGE_HEALTH';
export const UPDATE_PAGE_HEALTH_PERFORMANCE_WARNINGS = 'UPDATE_PAGE_HEALTH_PERFORMANCE_WARNINGS';
export const UPDATE_PAGE_HEALTH_SEO_WARNINGS = 'UPDATE_PAGE_HEALTH_SEO_WARNINGS';
export const UPDATE_PAGE_HEALTH_SCORE = 'UPDATE_PAGE_HEALTH_SCORE';
export const UPDATE_PAGE_HEALTH_SCORE_CANONICAL = 'UPDATE_PAGE_HEALTH_SCORE_CANONICAL';
export const UPDATE_ACTIVE_PAGE_HEALTH_CATEGORY = 'UPDATE_ACTIVE_PAGE_HEALTH_CATEGORY';
export const UPDATE_PAGE_HEALTH_SHOW_SEO_RECOMMENDATION = 'UPDATE_PAGE_HEALTH_SHOW_SEO_RECOMMENDATION';
export const UPDATE_PAGE_HEALTH_SHOW_IGNORED_STATUS = 'UPDATE_PAGE_HEALTH_SHOW_IGNORED_STATUS';

/** SPATIAL */
export const UPDATE_HYPERLINK_SLIDE = "UPDATE_HYPERLINK_SLIDE";

/**
 * Campaigns Actions
 */
export const FETCH_CAMPAIGNS_REQUEST = 'FETCH_CAMPAIGNS_REQUEST';
export const FETCH_CAMPAIGNS_SUCCEEDED = 'FETCH_CAMPAIGNS_SUCCEEDED';
export const FETCH_CAMPAIGNS_FAILED = 'FETCH_CAMPAIGNS_FAILED';

// Fetch Single Campaign
export const FETCH_CAMPAIGN_REQUEST = 'FETCH_CAMPAIGN_REQUEST';
export const FETCH_CAMPAIGN_SUCCEEDED = 'FETCH_CAMPAIGN_SUCCEEDED';
export const FETCH_CAMPAIGN_FAILED = 'FETCH_CAMPAIGN_FAILED';

// Create Campaign
export const CREATE_CAMPAIGN_REQUEST = 'CREATE_CAMPAIGN_REQUEST';
export const CREATE_CAMPAIGN_SUCCEEDED = 'CREATE_CAMPAIGN_SUCCEEDED';
export const CREATE_CAMPAIGN_FAILED = 'CREATE_CAMPAIGN_FAILED';

// Update Campaign
export const UPDATE_CAMPAIGN_REQUEST = 'UPDATE_CAMPAIGN_REQUEST';
export const UPDATE_CAMPAIGN_SUCCEEDED = 'UPDATE_CAMPAIGN_SUCCEEDED';
export const UPDATE_CAMPAIGN_FAILED = 'UPDATE_CAMPAIGN_FAILED';

// Enable Campaign
export const ENABLE_CAMPAIGN_REQUEST = 'ENABLE_CAMPAIGN_REQUEST';
export const ENABLE_CAMPAIGN_SUCCEEDED = 'ENABLE_CAMPAIGN_SUCCEEDED';
export const ENABLE_CAMPAIGN_FAILED = 'ENABLE_CAMPAIGN_FAILED';

// Clone Campaign
export const CLONE_CAMPAIGN_REQUEST = 'CLONE_CAMPAIGN_REQUEST';
export const CLONE_CAMPAIGN_SUCCEEDED = 'CLONE_CAMPAIGN_SUCCEEDED';
export const CLONE_CAMPAIGN_FAILED = 'CLONE_CAMPAIGN_FAILED';

// Delete Campaign
export const DELETE_CAMPAIGN_REQUEST = 'DELETE_CAMPAIGN_REQUEST';
export const DELETE_CAMPAIGN_SUCCEEDED = 'DELETE_CAMPAIGN_SUCCEEDED';
export const DELETE_CAMPAIGN_FAILED = 'DELETE_CAMPAIGN_FAILED';

export const SELECT_PERSONALIZATION_CAMPAIGN = 'SELECT_PERSONALIZATION_CAMPAIGN';

export const SELECT_PERSONALIZATION_AUDIENCE_SEGMENT = 'SELECT_PERSONALIZATION_AUDIENCE_SEGMENT';

export const FETCH_AUDIENCE_SEGMENTS_REQUEST = 'FETCH_AUDIENCE_SEGMENTS_REQUEST';
export const FETCH_AUDIENCE_SEGMENTS_SUCCEEDED = 'FETCH_AUDIENCE_SEGMENTS_SUCCEEDED';
export const FETCH_AUDIENCE_SEGMENTS_FAILED = 'FETCH_AUDIENCE_SEGMENTS_FAILED';

// Fetch Single Audience Segment
export const FETCH_AUDIENCE_SEGMENT_REQUEST = 'FETCH_AUDIENCE_SEGMENT_REQUEST';
export const FETCH_AUDIENCE_SEGMENT_SUCCEEDED = 'FETCH_AUDIENCE_SEGMENT_SUCCEEDED';
export const FETCH_AUDIENCE_SEGMENT_FAILED = 'FETCH_AUDIENCE_SEGMENT_FAILED';

// Create Audience Segment
export const CREATE_AUDIENCE_SEGMENT_REQUEST = 'CREATE_AUDIENCE_SEGMENT_REQUEST';
export const CREATE_AUDIENCE_SEGMENT_SUCCEEDED = 'CREATE_AUDIENCE_SEGMENT_SUCCEEDED';
export const CREATE_AUDIENCE_SEGMENT_FAILED = 'CREATE_AUDIENCE_SEGMENT_FAILED';

/**
 * Clone Audience Segment
 */
export const CLONE_AUDIENCE_SEGMENT_REQUEST = 'CLONE_AUDIENCE_SEGMENT_REQUEST';
export const CLONE_AUDIENCE_SEGMENT_SUCCEEDED = 'CLONE_AUDIENCE_SEGMENT_SUCCEEDED';
export const CLONE_AUDIENCE_SEGMENT_FAILED = 'CLONE_AUDIENCE_SEGMENT_FAILED';

export const UPDATE_AND_REORDER_AUDIENCE_SEGMENT_REQUEST = 'UPDATE_AND_REORDER_AUDIENCE_SEGMENT_REQUEST';

/**
 * Update Audience Segment
 */
export const UPDATE_AUDIENCE_SEGMENT_REQUEST = 'UPDATE_AUDIENCE_SEGMENT_REQUEST';
export const UPDATE_AUDIENCE_SEGMENT_SUCCEEDED = 'UPDATE_AUDIENCE_SEGMENT_SUCCEEDED';
export const UPDATE_AUDIENCE_SEGMENT_FAILED = 'UPDATE_AUDIENCE_SEGMENT_FAILED';

/**
 * Update Audience Segment Order
 */
export const UPDATE_AUDIENCE_SEGMENT_ORDER_REQUEST = 'UPDATE_AUDIENCE_SEGMENT_ORDER_REQUEST';
export const UPDATE_AUDIENCE_SEGMENT_ORDER_SUCCEEDED = 'UPDATE_AUDIENCE_SEGMENT_ORDER_SUCCEEDED';
export const UPDATE_AUDIENCE_SEGMENT_ORDER_FAILED = 'UPDATE_AUDIENCE_SEGMENT_ORDER_FAILED';

/**
 * Delete Audience Segment
 */
export const DELETE_AUDIENCE_SEGMENT_REQUEST = 'DELETE_AUDIENCE_SEGMENT_REQUEST';
export const DELETE_AUDIENCE_SEGMENT_SUCCEEDED = 'DELETE_AUDIENCE_SEGMENT_SUCCEEDED';
export const DELETE_AUDIENCE_SEGMENT_FAILED = 'DELETE_AUDIENCE_SEGMENT_FAILED';

export const INVALIDATE_CAMPAIGN_SELECTION = 'INVALIDATE_CAMPAIGN_SELECTION';
export const INVALIDATE_AUDIENCE_SEGMENT_SELECTION = 'INVALIDATE_AUDIENCE_SEGMENT_SELECTION';

export const INVALIDATE_CAMPAIGNS_AND_SEGMENTS = 'INVALIDATE_CAMPAIGNS_AND_SEGMENTS';

/**
 * Fetch Campaign Segments
 */
export const FETCH_CAMPAIGNS_SEGMENTS_REQUEST = 'FETCH_CAMPAIGNS_SEGMENTS_REQUEST';
export const FETCH_CAMPAIGNS_SEGMENTS_SUCCEEDED = 'FETCH_CAMPAIGNS_SEGMENTS_SUCCEEDED';
export const FETCH_CAMPAIGNS_SEGMENTS_FAILED = 'FETCH_CAMPAIGNS_SEGMENTS_FAILED';

/**
 * Workspace Charts Metrics Reports
 */
export const FETCHING_WORKSPACE_CHARTS_METRICS_REPORTS = "FETCHING_WORKSPACE_CHARTS_METRICS_REPORTS";
export const FETCHING_WORKSPACE_CHARTS_METRICS_REPORTS_SUCCEEDED = "FETCHING_WORKSPACE_CHARTS_METRICS_REPORTS_SUCCEEDED";
export const FETCHING_WORKSPACE_CHARTS_METRICS_REPORTS_FAILED = "FETCHING_WORKSPACE_CHARTS_METRICS_REPORTS_FAILED";

export const FETCHING_WORKSPACE_METRICS_REPORTS = "FETCHING_WORKSPACE_METRICS_REPORTS";
export const FETCHING_WORKSPACE_METRICS_REPORTS_SUCCEEDED = "FETCHING_WORKSPACE_METRICS_REPORTS_SUCCEEDED";
export const FETCHING_WORKSPACE_METRICS_REPORTS_FAILED = "FETCHING_WORKSPACE_METRICS_REPORTS_FAILED";

/**
 * Copy Paste Editor Animation
 */
export const COPY_PASTE_EDITOR_ANIMATION = 'COPY_PASTE_EDITOR_ANIMATION';

/**
 * AI Mobile Optimization Actions
 */
export const AI_MOBILE_OPTIMIZATION_REQUEST = 'AI_MOBILE_OPTIMIZATION_REQUEST';
export const AI_MOBILE_OPTIMIZATION_SUCCEEDED = 'AI_MOBILE_OPTIMIZATION_SUCCEEDED';
export const AI_MOBILE_OPTIMIZATION_FAILED = 'AI_MOBILE_OPTIMIZATION_FAILED';

export const DESKTOP_TO_MOBILE_OPTIMIZE = 'DESKTOP_TO_MOBILE_OPTIMIZE';

export const DESKTOP_TO_MOBILE_OPTIMIZE_REQUEST = 'DESKTOP_TO_MOBILE_OPTIMIZE_REQUEST';
export const DESKTOP_TO_MOBILE_OPTIMIZE_SUCCEEDED = 'DESKTOP_TO_MOBILE_OPTIMIZE_SUCCEEDED';
export const DESKTOP_TO_MOBILE_OPTIMIZE_FAILED = 'DESKTOP_TO_MOBILE_OPTIMIZE_FAILED';
export const INVALIDATE_MOBILE_OPTIMIZATION_STATE = 'INVALIDATE_MOBILE_OPTIMIZATION_STATE';

export const MOBILE_LAYOUT_OPTIMIZE = 'AI_MOBILE_LAYOUT_OPTIMIZE';

export const MOBILE_LAYOUT_OPTIMIZE_REQUEST = 'MOBILE_LAYOUT_OPTIMIZE_REQUEST';
export const MOBILE_LAYOUT_OPTIMIZE_SUCCEEDED = 'MOBILE_LAYOUT_OPTIMIZE_SUCCEEDED';
export const MOBILE_LAYOUT_OPTIMIZE_FAILED = 'MOBILE_LAYOUT_OPTIMIZE_FAILED';
export const INVALIDATE_MOBILE_LAYOUT_OPTIMIZATION_STATE = 'INVALIDATE_MOBILE_LAYOUT_OPTIMIZATION_STATE';

export const DESKTOP_TO_MOBILE_PLAN_AND_OPTIMIZE = 'DESKTOP_TO_MOBILE_PLAN_AND_OPTIMIZE';

export const DESKTOP_TO_MOBILE_PLAN_AND_OPTIMIZE_REQUEST = 'DESKTOP_TO_MOBILE_PLAN_AND_OPTIMIZE_REQUEST';
export const DESKTOP_TO_MOBILE_PLAN_AND_OPTIMIZE_SUCCEEDED = 'DESKTOP_TO_MOBILE_PLAN_AND_OPTIMIZE_SUCCEEDED';
export const DESKTOP_TO_MOBILE_PLAN_AND_OPTIMIZE_FAILED = 'DESKTOP_TO_MOBILE_PLAN_AND_OPTIMIZE_FAILED';
export const INVALIDATE_MOBILE_PLAN_AND_OPTIMIZATION_STATE = 'INVALIDATE_MOBILE_PLAN_AND_OPTIMIZATION_STATE';


/**
 * Prompt Editor Actions
 */
export const PROMPT_EDITOR_SECTION_REQUEST = 'PROMPT_EDITOR/SECTION/REQUEST';
export const PROMPT_EDITOR_SECTION_MESSAGE = 'PROMPT_EDITOR/SECTION/MESSAGE';
export const PROMPT_EDITOR_SECTION_SUCCEEDED = 'PROMPT_EDITOR/SECTION/SUCCEEDED';
export const PROMPT_EDITOR_SECTION_FAILED = 'PROMPT_EDITOR/SECTION/FAILED';
export const PROMPT_EDITOR_SECTION_CANCEL = 'PROMPT_EDITOR/SECTION/CANCEL';
export const UPDATE_AI_IMAGE_WIDGET_CONTENT_FAILED = 'UPDATE_AI_IMAGE_WIDGET_CONTENT_FAILED';

export const CREATE_WIDGETS_FOR_PROMPT_SECTIONS = 'CREATE_WIDGETS_FOR_PROMPT_SECTIONS';

export const PROCESS_PROMPT_WIDGET_REQUEST = 'PROCESS_PROMPT_WIDGET_REQUEST';
export const PROCESSING_PROMPT_WIDGET_SUCCEEDED = 'PROCESSING_PROMPT_WIDGET_SUCCEEDED';
export const PROCESSING_PROMPT_WIDGET_FAILED = 'PROCESSING_PROMPT_WIDGET_FAILED';
export const PROCESS_ALL_PROMPT_WIDGETS_COMPLETED = 'PROCESS_ALL_PROMPT_WIDGETS_COMPLETED';

export const UPDATE_AI_IMAGE_WIDGET_CONTENT = 'UPDATE_AI_IMAGE_WIDGET_CONTENT';
export const UPDATE_AI_WIDGET_BACKGROUND = 'UPDATE_AI_WIDGET_BACKGROUND';

export const CREATE_WIDGET_FROM_HTML_REQUEST = 'CREATE_WIDGET_FROM_HTML_REQUEST';
export const CREATE_WIDGET_FROM_HTML_SUCCEEDED = 'CREATE_WIDGET_FROM_HTML_SUCCEEDED';
export const CREATE_WIDGET_FROM_HTML_FAILED = 'CREATE_WIDGET_FROM_HTML_FAILED';
export const PROCESS_HTML_TO_WIDGET_REQUEST = 'PROCESS_HTML_TO_WIDGET_REQUEST';


// IC V2 - Achors
export const FETCH_ANCHORS_REQUEST = 'FETCH_ANCHORS_REQUEST';
export const FETCH_ANCHORS_SUCCESS = 'FETCH_ANCHORS_SUCCESS';
export const FETCH_ANCHORS_FAILED = 'FETCH_ANCHORS_FAILED';

export const INTIALISE_ICV2_PAGES = 'INTIALISE_ICV2_PAGES'
export const UPDATE_IC_V2_ACTIVE = 'UPDATE_IC_V2_ACTIVE'

export const FETCH_PAGE_SNAPDHOT_REQUEST = 'FETCH_PAGE_SNAPDHOT_REQUEST';

export const STORYBOARD_LEVEL_SEEK_INDEX_REQUEST = 'STORYBOARD_LEVEL_SEEK_INDEX_REQUEST';
export const STORYBOARD_LEVEL_SEEK_INDEX_SUCCEEDED = 'STORYBOARD_LEVEL_SEEK_INDEX_SUCCEEDED';
export const STORYBOARD_LEVEL_SEEK_INDEX_FAILED = 'STORYBOARD_LEVEL_SEEK_INDEX_FAILED';